import {
  Form,
  Input,
  InputNumber,
  Button,
  Tabs,
  Radio,
  Select,
  DatePicker,
  Upload,
  notification,
  message,
  Row,
  Col,
  Modal,
  Divider,
  Typography,
  Table,
  Space,
  Tag,
  Tooltip,
  Image,
  Collapse,
  Checkbox,
  Popover,
  Breadcrumb,
  Card,
  Spin,
  Switch,
} from "antd";
import {
  LoadingOutlined,
  PlusOutlined,
  InfoCircleOutlined,
  WarningFilled,
  ArrowDownOutlined,
  ArrowUpOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  PlaySquareFilled,
  EditFilled,
  DeleteFilled,
  DownOutlined,
  RightOutlined,
  PlusSquareOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleOutlined,
  InfoCircleTwoTone,
  QuestionCircleOutlined,
  DownloadOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import moment from "moment";
import dayjs from "dayjs";

import "./styles.css";
import { Context } from "../../context";
import { Delete, Fetch, Post, Put } from "../../fetch";
import { convertIdToKey, countryCodes, currencycodes } from "../../utils";
import UploadVideo from "../UploadContent/videos";
import UploadTrailer from "../UploadContent/trailers";
import UploadSubtitles from "../UploadContent/subtitles";
import Column from "antd/lib/table/Column";
import Episode from "./episode";
import {
  validateInputSlug,
  validateNumberField,
  validateOptionalNumberField,
  validateApplePodcastInput,
  validateSpotifyInput,
  validateYoutubeInput,
} from "../../validators";
import HtmlDisplay from "./EmbedCopy";
import { TreeSelect } from "antd";
import DirectUpload from "../UploadContent/directupload";

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;
const { Panel } = Collapse;
const { confirm } = Modal;

const ManageMarkettingContent = ({ updateTab }) => {
  const [spin, setSpin] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeKey, setActiveKey] = useState("1");
  const [contentKey, setContentKey] = useState("1");
  const [refresh, setRefresh] = useState(false);
  const [refreshMovies, setRefreshMovies] = useState(false);
  const [refreshSeries, setRefreshSeries] = useState(false);
  const [contentType, setContentType] = useState("movie");
  const [availability, setAvailability] = useState("perpetual");
  const [monetizationModel, setMonetizationModel] = useState("");
  const [modelType, setModelType] = useState("default");
  const [movies, setMovies] = useState([]);
  const [moviesMaster, setMoviesMaster] = useState([]);
  const [series, setSeries] = useState([]);
  const [seriesMaster, setSeriesMaster] = useState([]);
  const [albums, setAlbums] = useState([]);
  const [saved, setSaved] = useState(false);
  const [maturityTpe, setMaturityType] = useState("CBFC");
  const [count, setCount] = useState(0);
  const [activeObj, setActiveObj] = useState({});
  const [listType, setListType] = useState("allow_all");
  const [showModal, setShowModal] = useState(false);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [seriesRecord, setSeriesRecord] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [showTitle, setShowTitle] = useState(false);
  const [filter, setFilter] = useState("all");
  const [Telugu, setTelugu] = useState(false);
  const [Hindi, setHindi] = useState(false);
  const [Tamil, setTamil] = useState(false);
  const [title, setTitle] = useState(false);
  const [ratingType, setRatingType] = useState("CBFC");
  const [streamType, setStreamType] = useState("default");
  const [checked, setChecked] = useState(false);
  const [episodeTitle, setEpisodeTitle] = useState(null);
  const [id, setId] = useState("");
  const [role, setRole] = useState("");
  const [upload, setUpload] = useState({
    id: null,
    season: null,
    episode: null,
    type: "",
  });

  const initUpload = {
    id: null,
    season: null,
    episode: null,
    type: "",
  };

  useEffect(() => {
    setActiveObj({});
    setUpload(initUpload);
    console.log("Manage Content - 1");
  }, [contentType]);

  const codes = ["INR", "BDT", "GBP", "NPR", "MUR", "SGD", "AED", "EUR", "USD"];

  const [seriesId, setSeriesId] = useState();
  const [episodesData, setEpisodesData] = useState([]);
  const [currentSeason, setCurrentSeason] = useState([]);
  const [seasonList, setSeasonList] = useState([]);
  const ep_form = [];
  const [seriesName, setSeriesName] = useState("");
  const [season, setSeason] = useState(1);
  const [movie, setMovie] = useState();
  const [movieName, setMovieName] = useState("");
  const [deleteEpisode, setDeleteEpisode] = useState({});
  const allowList = [];
  let del_list = [];
  const [dateString, setDateString] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const [deleteFlag, setDeleteFlag] = useState(false);

  const { token, apiUrl, superAdmin } = useContext(Context);

  const [contentInfoForm] = Form.useForm();
  const [seriesContentInfoForm] = Form.useForm();

  const [castCrewAvailabilityForm] = Form.useForm();
  const [seriesCastCrewAvailabilityForm] = Form.useForm();

  const [availabilityForm] = Form.useForm();
  const [seriesAvailabilityForm] = Form.useForm();

  const [episodesForm] = Form.useForm();

  const [posterBannersForm] = Form.useForm();
  const [geoAccessForm] = Form.useForm();
  const [monetizationStreamingForm] = Form.useForm();
  const [standAloneForm] = Form.useForm();
  const [titleForm] = Form.useForm();
  const [videoAssetsForm] = Form.useForm();

  const [actors, setActors] = useState([]);
  const [directors, setDirectors] = useState([]);
  const [writers, setWriters] = useState([]);
  const [studios, setStudios] = useState([]);
  const [singers, setSingers] = useState([]);
  const [lyricists, setLyricists] = useState([]);
  const [genres, setGenres] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [creators, setCreators] = useState([]);
  const [hosts, setHosts] = useState([]);
  const [guests, setGuests] = useState([]);
  const [tech, setTech] = useState([]);

  const [cardImageLoading, setCardImageLoading] = useState(false);
  const [detailImageLoading, setDetailImageLoading] = useState(false);
  const [trailerImageLoading, setTrailerImageLoading] = useState(false);
  const [logoImageLoading, setLogoImageLoading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [cardImageUrl, setCardImageUrl] = useState();
  const [detailImageUrl, setDetailImageUrl] = useState();
  const [trailerImageUrl, setTrailerImageUrl] = useState();
  const [logoImageUrl, setLogoImageUrl] = useState();
  const [addStandaloneContent, setAddStandaloneContent] = useState(false);
  const [addSeriesContent, setAddSeriesContent] = useState(false);
  const [seriesTitleModal, setSeriesTitleModal] = useState(false);
  const [seriesTitleModalType, setSeriesTitleModalType] = useState("Add");
  const [seasonId, setSeasonId] = useState(null);
  const [selectionType, setSelectionType] = useState("checkbox");
  const [subtitlesUploaded, setSubtitlesUploaded] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [releaseDate, setReleaseDate] = useState();
  const [currentEpisode, setCurrentEpisode] = useState(null);
  const [episodeModalVisible, setEpisodeModalVisible] = useState(false);
  const [seasonEpisodes, setSeasonEpisodes] = useState([]);
  const { Text, Link, Title } = Typography;

  const [addStandloneTitleForm] = Form.useForm();
  const [addSeriesTitleForm] = Form.useForm();
  const [episodeTItleForm] = Form.useForm();

  // gating content treeselect and selelected Value
  const [gatingType, setGatingType] = useState(false); // for standalone content

  // on click edit modal for series get that episodes for that series
  const getSeasonEpisodes = (record) => {
    Fetch(`${apiUrl}/episodes/all?id=${record?.key}`, token, (result) => {
      const episodes = convertIdToKey(result.episodes);
      setSeasonEpisodes(episodes);
    });
  };

  // tree data for gating content
  const groupEpisodesBySeason = (episodes) => {
    let tree = [];
    console.log("episodes", episodes);
    episodes.forEach((asset) => {
      tree.push({
        title: `Season ${asset.season}`,
        value: asset["key"],
        children: asset["episodes"].map((segment) => {
          return {
            ...segment,
            value: asset["key"] + "_" + segment["_id"],
          };
        }),
      });
    });
    return tree;
  };
  const treeData = groupEpisodesBySeason(seasonEpisodes);

  const ratings = [
    {
      type: "CBFC — Central Board of Film Certification",
      value: "CBFC",
    },
    {
      type: "BR Official Rating",
      value: "BR",
    },
  ];

  let ratingValues =
    ratingType === "CBFC"
      ? [
        {
          key: "U",
          value: "U",
        },
        {
          key: "U/A",
          value: "U/A",
        },
        {
          key: "A",
          value: "A",
        },
        {
          key: "S",
          value: "S",
        },
      ]
      : ratingType === "BR"
        ? [
          {
            key: "L",
            value: "L",
          },
          {
            key: "10",
            value: "10",
          },
          {
            key: "12",
            value: "12",
          },
          {
            key: "14",
            value: "14",
          },
          {
            key: "16",
            value: "16",
          },
          {
            key: "18",
            value: "18",
          },
        ]
        : [];

  //  Episodes Sorting Buttons
  const episodesSortingButtons = () => {
    return (
      <>
        <Button style={{ marginRight: "10px" }}>
          <ArrowDownOutlined />
        </Button>
        <Button>
          <ArrowUpOutlined />
        </Button>
      </>
    );
  };

  //  addLanguage Popover
  const addLanguagePopover = () => {
    return (
      <Row>
        <Col span="24">
          <Checkbox
            onChange={(e) => setTelugu(e.target.checked)}
            checked={Telugu}
          >
            Spanish
          </Checkbox>
          <br />
          <Checkbox
            onChange={(e) => setHindi(e.target.checked)}
            checked={Hindi}
          >
            German
          </Checkbox>
          <br />
          <Checkbox
            onChange={(e) => setTamil(e.target.checked)}
            checked={Tamil}
          >
            French
          </Checkbox>
        </Col>
      </Row>
    );
  };

  useEffect(() => {
    //  setCount(contentKey);
    console.log("Manage content - ", 2);

    return () => {
      setAddStandaloneContent(false);
      console.log("Component unmounted");
    };
  }, [contentType, activeTab]);

  const cardImageUploadButton =
    contentType === "movie" || contentType === "song" ? (
      <div>
        {cardImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload (300x400)</div>
      </div>
    ) : (
      <div>
        {cardImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload (450x250)</div>
      </div>
    );

  const detailImageUploadButton = (
    <div>
      {detailImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload (1500x500)</div>
    </div>
  );

  const trailerImageUploadButton = (
    <div>
      {trailerImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload (512x288)</div>
    </div>
  );

  const beforeImageUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("Only JPG and PNG files are allowed");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must be smaller than 2M");
    }

    return isJpgOrPng && isLt2M;
  };

  const handleCardImageUploadStatusChange = (info) => {
    if (info.file.status === "uploading") {
      setCardImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setCardImageLoading(false);
      const url = info.file.response.url + "/cardImage";
      setCardImageUrl(url);
      posterBannersForm.setFieldsValue({ cardImage: url });
      setUploadStatus(false);
    }
  };

  const handleDetailImageUploadStatusChange = (info) => {
    if (info.file.status === "uploading") {
      setDetailImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setDetailImageLoading(false);
      const url = info.file.response.url + "/detailImage";
      setDetailImageUrl(url);
      posterBannersForm.setFieldsValue({ detailImage: url });
    }
  };

  const handleTrailerImageUploadStatusChange = (info) => {
    if (info.file.status === "uploading") {
      setTrailerImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setTrailerImageLoading(false);
      const url = info.file.response.url + "/trailerImage";
      setTrailerImageUrl(url);
      posterBannersForm.setFieldsValue({
        trailerImage: url,
      });
    }
  };

  const handleLogoImageUploadStatusChange = (info) => {
    console.log("logo image upload - ", info);
    if (info.file.status === "uploading") {
      setLogoImageLoading(true);
      return;
    }

    if (info.file.status === "done") {
      setLogoImageLoading(false);
      const url = info.file.response.url + "/logoImage";
      setLogoImageUrl(url);
      posterBannersForm.setFieldsValue({
        logoImage: url,
      });
    }
  };

  const handlePreview = (info) => {
    console.log("info - ", info);
  };

  useEffect(() => {
    Fetch(`${apiUrl}/movies`, token, (result) => {
      let movies = convertIdToKey(result.movies);
      let m = [];
      movies.forEach((movie) => {
        if (movie.availability === "unpublished") {
          movie["status"] = "Unpublished";
        } else if (movie.availability === "perpetual") {
          movie["status"] = "Published";
        } else if (movie.availability === "restricted") {
          if (dayjs().isAfter(dayjs(movie.startDate))) {
            movie["status"] = "Published";
          } else {
            movie["status"] = `restricted`;
          }
        }
        if (!movie.title) {
          movie["title"] = "NA";
        }
        if (filter === "draft" && movie["status"] === "Unpublished") {
          m.push(movie);
        } else if (filter === "published" && movie["status"] === "Published") {
          m.push(movie);
        } else if (
          filter === "restricted" &&
          movie["status"] === "restricted"
        ) {
          m.push(movie);
        }
        if (filter === "all") {
          m.push(movie);
        }
      });
      movies.forEach((movie) => {
        if (typeof movie["genre"] === "string") {
          movie["genre"] = [movie["genre"]];
        }

        // if (!movie.duration) {
        //     movie.duration = "--:--:--";
        // } else {
        //     let h, m, s;
        //     let d = Number(movie.duration);
        //     h = Math.floor(d / 3600).toString();
        //     m = Math.floor(d % 3600 / 60).toString();
        //     s = Math.floor(d % 3600 % 60).toString();
        //     let H = h < 10 ? `0${h}` : `${h}`;
        //     let M = m < 10 ? `0${m}` : `${m}`;
        //     let S = s < 10 ? `0${s}` : `${s}`;
        //     movie.duration = `${H}:${M}:${S}`
        // }
        if (movie.createdAt) {
          movie.createdAt = moment(movie.createdAt).format(
            "DD/MM/YYYY hh:mm A"
          );
        } else {
          movie.createdAt = "-";
        }
      });
      setMovies(m);
      setMoviesMaster(m);
      setRefreshMovies(false);
    });

    Fetch(`${apiUrl}/series`, token, (result) => {
      let series = convertIdToKey(result.series);
      let m = [];
      series.forEach((s) => {
        if (s.availability) {
          if (s.availability === "unpublished") {
            s["status"] = "Unpublished";
          } else if (s.availability === "perpetual") {
            s["status"] = "Published";
          } else if (s.availability === "restricted") {
            if (dayjs().isAfter(dayjs(s.startDate))) {
              s["status"] = "Published";
            } else {
              s["status"] = `restricted`;
            }
          }
        }
        if (filter === "draft" && s["status"] === "Unpublished") {
          m.push(s);
        } else if (filter === "published" && s["status"] === "Published") {
          m.push(s);
        } else if (filter === "restricted" && s["status"] === "restricted") {
          m.push(s);
        }
        if (filter === "all") {
          m.push(s);
        }
      });
      series.forEach((su) => {
        if (!su.videoUploadDateTime) {
          su.videoUploadDateTime = "NA";
        } else {
          su.videoUploadDateTime = moment(su.videoUploadDateTime).format(
            "DD/MM/YYYY hh:mm A"
          );
        }
        if (!su.duration) {
          su.duration = "--:--:--";
        } else {
          let h, m, s;
          let d = Number(su.duration);
          h = Math.floor(d / 3600).toString();
          m = Math.floor((d % 3600) / 60).toString();
          s = Math.floor((d % 3600) % 60).toString();
          let H = h < 10 ? `0${h}` : `${h}`;
          let M = m < 10 ? `0${m}` : `${m}`;
          let S = s < 10 ? `0${s}` : `${s}`;
          su.duration = `${H}:${M}:${S}`;
        }
        if (su.createdAt) {
          su.createdAt = moment(su.createdAt).format("DD/MM/YYYY hh:mm A");
        } else {
          su.createdAt = "-";
        }
      });
      setSeries(m);
      setSeriesMaster(m);
      setRefreshSeries(false);
    });

    Fetch(`${apiUrl}/crew`, token, (result) => {
      setHosts(result.hosts);
      setGuests(result.guests);
      setTech(result.tech);
      setCreators(result.creators);
    });

    Fetch(`${apiUrl}/genres`, token, (result) => {
      setGenres(result.genres);
    });

    Fetch(`${apiUrl}/languages`, token, (result) => {
      setLanguages(result.languages);
    });
    sessionStorage.removeItem("content_id");
    setAddStandaloneContent(false);
    setAddSeriesContent(false);
    setShowTable(true);
    contentInfoForm.resetFields();
    seriesContentInfoForm.resetFields();
    castCrewAvailabilityForm.resetFields();
    seriesCastCrewAvailabilityForm.resetFields();
    videoAssetsForm.resetFields();
    episodesForm.resetFields();
    monetizationStreamingForm.resetFields();
    geoAccessForm.resetFields();
    availabilityForm.resetFields();
    seriesAvailabilityForm.resetFields();
    monetizationStreamingForm.resetFields();
    setStreamType("default");
    setCardImageUrl(null);
    setDetailImageUrl(null);
    setTrailerImageUrl(null);
    setLogoImageUrl(null);
    setTelugu(false);
    setHindi(false);
    setTamil(false);
    setActiveKey("1");
    setExpandedRow(null);
  }, [apiUrl, token, filter, refreshMovies, refreshSeries]);

  const updateContentInfoSubmit = (record) => {
    if (record.key === undefined) {
      return;
    }
    handleFetchMovie(record);
    setActiveKey("2");
  };

  const updateSeriesContentInfoSubmit = (record) => {
    if (record.key === undefined) {
      return;
    }
    handleFetchSeries(record);
    setActiveKey("2");
  };

  const handleContentInfoSubmit = async () => {
    let contentInfo = await contentInfoForm.validateFields();
    console.log("content info form values  - ", contentInfo);
    let valid = true;
    try {
      contentInfo = await contentInfoForm.validateFields();
      if (contentInfo.releaseDate) {
        contentInfo.releaseDate = contentInfo.releaseDate.format("YYYY-MM-DD");
      }
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Content Info Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
    }
    let metaLanguages = ["english"];
    if (Telugu) {
      metaLanguages = [...metaLanguages, "telugu"];
    }
    if (Hindi) {
      metaLanguages = [...metaLanguages, "hindi"];
    }
    if (Tamil) {
      metaLanguages = [...metaLanguages, "tamil"];
    }
    contentInfo = {
      ...contentInfo,
      metaLanguages: metaLanguages,
      cardImage: cardImageUrl,
      detailImage: detailImageUrl,
      trailerImage: trailerImageUrl,
      logoImage: logoImageUrl,
      availability: availability,
    };
    if (contentType === "movie") {
      let movieId = sessionStorage.getItem("content_id");
      Put(
        `${apiUrl}/movies/${movieId}`,
        token,
        { ...contentInfo },
        (result) => {
          if (result.success === true) {
            notification.success({
              message: "Success",
              description: "Movie Saved",
            });
            sessionStorage.removeItem("expandedRow");
            updateContentInfoSubmit({ key: movieId });
            setActiveKey("2");
          } else if (result.success === false) {
            notification.error({
              message: "Error updating movie",
              description: result["message"],
            });
          }
        }
      );
    }
    console.log(seriesId);
    if (contentType === "series" && seriesId) {
      // console.log('series id before api call - ', seriesId)
      Post(
        `${apiUrl}/series/${seriesId}/episodes`,
        token,
        { ...contentInfo },
        (result) => {
          console.log(result);
          if (result.success) {
            sessionStorage.setItem("content_id", seriesId);
            console.log(sessionStorage.getItem("content_id"));
            notification.success({
              message: "Success",
              description: "Episode Saved",
            });
            // console.log(contentInfo)
            sessionStorage.setItem("episode_data", JSON.stringify(contentInfo));
            console.log(
              "episode data after updating - ",
              JSON.parse(sessionStorage.getItem("episode_data"))
            );
          }
        }
      );
    }
    if (contentType === "song") {
      Post(`${apiUrl}/songs`, token, { ...contentInfo }, (result) => {
        if (result.success) {
          console.log("song id - ", result.success);
          sessionStorage.setItem("content_id", result.success);
          notification.success({
            message: "Success",
            description: "Song Saved",
          });
        }
      });
    }
  };

  const handleSeriesContentInfoSubmit = async () => {
    let contentInfo = await seriesContentInfoForm.validateFields();
    let valid = true;
    try {
      contentInfo = await seriesContentInfoForm.validateFields();
      if (contentInfo.releaseDate) {
        contentInfo.releaseDate = contentInfo.releaseDate.format("YYYY-MM-DD");
      }
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Content Info Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
    }
    let metaLanguages = ["english"];
    if (Telugu) {
      metaLanguages = [...metaLanguages, "telugu"];
    }
    if (Hindi) {
      metaLanguages = [...metaLanguages, "hindi"];
    }
    if (Tamil) {
      metaLanguages = [...metaLanguages, "tamil"];
    }
    contentInfo = {
      ...contentInfo,
      metaLanguages: metaLanguages,
      cardImage: cardImageUrl,
      detailImage: detailImageUrl,
      trailerImage: trailerImageUrl,
      logoImage: logoImageUrl,
      availability: availability,
    };
    let id = sessionStorage.getItem("content_id");
    if (id) {
      Put(
        `${apiUrl}/seasons/${seasonId}`,
        token,
        { ...contentInfo },
        (result) => {
          console.log(result);
          if (result.success === true) {
            notification.success({
              message: "Success",
              description: "Season Saved",
            });
            updateSeriesContentInfoSubmit({ key: id });
            sessionStorage.removeItem("expandedRow");
            setActiveKey("2");
          } else if (result.success === false) {
            notification.error({
              message: "Error Updating Season",
              description: result["message"],
            });
          }
        }
      );
    }
  };

  const handleCastCrewSubmit = async () => {
    let castCrewAvailability;
    let valid = false;
    try {
      castCrewAvailability = await castCrewAvailabilityForm.validateFields();
      console.log(castCrewAvailability);
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Cast & Crew Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
      return;
    }
    let id = sessionStorage.getItem("content_id");
    if (id) {
      console.log("content_id - ", id);
      if (contentType === "movie") {
        Put(
          `${apiUrl}/movies/${id}`,
          token,
          {
            ...castCrewAvailability,
            availability: availability,
          },
          (result) => {
            if (result.success) {
              notification.success({
                message: "Success",
                description: "Movie Saved",
              });
              setActiveKey("3");
              sessionStorage.removeItem("expandedRow");
            }
          }
        );
      }
      if (contentType === "series" && seriesId) {
        try {
          const castCrewAvailability =
            await castCrewAvailabilityForm.validateFields();
          let episode = JSON.parse(sessionStorage.getItem("episode_data"));
          // console.log('episode data before updating cast crew - ', episode)
          let newEpisode = { ...episode, ...castCrewAvailability };
          Post(
            `${apiUrl}/series/${seriesId}/episodes`,
            token,
            {
              ...newEpisode,
              old: { ...episode },
            },
            (result) => {
              if (result.success) {
                notification.success({
                  message: "Success",
                  description: "Epsiode edited",
                });
                sessionStorage.setItem(
                  "episode_data",
                  JSON.stringify(newEpisode)
                );
                // console.log("episode data after cast and Crew - ", JSON.parse(sessionStorage.getItem('episode_data')))
              }
            },
            () => {
              notification.error({
                message: "Error",
                description: "Please check console for more details",
              });
            }
          );
        } catch (err) {
          console.error(err);
          notification.error({
            message: "Error",
            description: "Required fields incorrect/missing",
          });
        }
      }
      if (contentType === "song") {
        Put(
          `${apiUrl}/songs/${id}`,
          token,
          { ...castCrewAvailability },
          (result) => {
            if (result.success) {
              notification.success({
                message: "Success",
                description: "Song Saved",
              });
            }
          }
        );
      }
    }
  };

  const handleSeriesCastCrewSubmit = async () => {
    let castCrewAvailability;
    let valid = false;
    try {
      castCrewAvailability =
        await seriesCastCrewAvailabilityForm.validateFields();
      console.log(castCrewAvailability);
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Cast & Crew Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
      return;
    }
    let id = sessionStorage.getItem("content_id");
    if (id) {
      console.log("content_id - ", id);
      try {
        Put(
          `${apiUrl}/seasons/${seasonId}`,
          token,
          {
            ...castCrewAvailability,
            availability: availability,
          },
          (result) => {
            if (result.success) {
              notification.success({
                message: "Success",
                description: "Season Saved",
              });
              setActiveKey("3");
              sessionStorage.removeItem("expandedRow");
            }
          },
          () => {
            notification.error({
              message: "Error",
              description: "Please check console for more details",
            });
          }
        );
      } catch (err) {
        console.error(err);
        notification.error({
          message: "Error",
          description: "Required fields incorrect/missing",
        });
      }
    }
  };

  const handleVideoAssestsSubmit = async () => {
    let videoAssets;
    let valid = false;
    try {
      videoAssets = await videoAssetsForm.validateFields();
      videoAssets = { ...videoAssets, enable_subs: checked };
      valid = true;
      // console.log(videoAssets);
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Video Assets Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
    }
    if (videoAssets.skipIntroStart && videoAssets.skipIntroEnd) {
      if (videoAssets.skipIntroStart >= videoAssets.skipIntroEnd) {
        notification.error({
          message: "Error Updating Content",
          description: "Skip Inro End must be greater than Skip Intro Start",
        });
        return;
      }
    }
    let id = sessionStorage.getItem("content_id");
    if (id && valid) {
      // console.log("content_id - ", id);
      if (contentType === "movie") {
        Put(
          `${apiUrl}/movies/${id}`,
          token,
          {
            ...videoAssets,
            availability: availability,
          },
          (result) => {
            if (result.success) {
              notification.success({
                message: "Success",
                description: "Movie Saved",
              });
              setActiveKey("4");
              sessionStorage.removeItem("expandedRow");
            }
          }
        );
      }
    }
  };

  const handleDeleteEpisode = async (key, checked) => {
    // console.log('epsode number - ', key);
    // console.log('should delete - ', checked);
    del_list.push({ key: key, delete: checked });
  };

  const checkSubmitValidation = (data) => {
    let accept = data.filter((v) => "del_box" in v && v["del_box"] === false);
    let valid = true;
    accept.forEach((e) => {
      if (!e["ep_cardImage"] || !e["title"] || !e["ep_description"]) {
        valid = false;
        console.log("title data missing");
      }
      if (Telugu && !(e["title_telugu"] && e["ep_description_telugu"])) {
        valid = false;
        console.log("telugu data missing");
      }
      if (Hindi && !e["title_hindi"] && !e["ep_description_hindi"]) {
        valid = false;
        console.log("hindi data missing");
      }
      if (Tamil && !e["title_tamil"] && !e["ep_description_tamil"]) {
        valid = false;
        console.log("tamil data missing");
      }
    });

    return valid;
  };

  // True when an episode is missing any required field (honouring the languages).
  const episodeHasMissingRequired = (ep) => {
    if (!ep) return false;
    const isEmpty = (v) =>
      v === undefined ||
      v === null ||
      (typeof v === "string" && v.trim() === "") ||
      (Array.isArray(v) && v.length === 0);
    const required = ["title", "description", "creator", "detailImage"];
    if (Telugu) required.push("title_telugu", "description_telugu");
    if (Hindi) required.push("title_hindi", "description_hindi");
    if (Tamil) required.push("title_tamil", "description_tamil");
    return required.some((field) => isEmpty(ep[field]));
  };

  // Warning shown in the collapsed episode header when required fields are empty.
  const renderEpisodeHeaderWarning = (ep) => {
    if (!episodeHasMissingRequired(ep)) return null;
    return (
      <Text type="warning" style={{ marginLeft: "12px" }}>
        <span>
          <WarningFilled />
        </span>{" "}
        Required fields not filled
      </Text>
    );
  };

  const handleEpisodeSubmit = async () => {
    let episodes = {};
    try {
      episodes = await episodesForm.validateFields();
    } catch (err) {
      console.log("err - ", err);
      notification.error({
        message: "Error",
        description: "Required fields are missing/incorrect",
      });
      return;
    }
    // console.log("episodes data - ", episodes)
    // console.log('episodes data in submit - ', episodes.episodes)
    // console.log('del_list - ', del_list)
    let ep_data = episodes.episodes;
    let values = [];
    console.log("ep_data - ", ep_data);
    ep_data = ep_data.filter((v) => v !== undefined);
    console.log("check data - ", checkSubmitValidation(ep_data));
    if (!checkSubmitValidation(ep_data)) {
      notification.error({
        message: "Update Episodes Error",
        description: "Required fields are missing",
      });
      return;
    }
    let subs = JSON.parse(sessionStorage.getItem("subtitles_data"));
    console.log("subtitles object for submit - ", subs);
    ep_data.forEach((ep) => {
      ep["season"] = season;
      // console.log("iterating through each episode", ep)
      try {
        ep["ep_cardImage"] = ep["ep_cardImage"].file.response.url;
        if (subs) {
          if (
            subs.season.season === season &&
            ep["ep_number"] === subs.season.episode
          ) {
            // console.log("subtitles match for ep - ", ep["ep_number"])
            ep["subtitles"] = {
              ...ep["subtitles"],
              [subs.language]: subs.subtitles,
            };
          }
        }
      } catch {
        console.log("ep => ", ep);
        ep["ep_cardImage"] = ep["ep_cardImage"];
        if (subs) {
          if (
            subs.season.season === season &&
            ep["ep_number"] === subs.season.episode
          ) {
            // console.log("subtitles match for ep - ", ep["ep_number"])
            ep["subtitles"] = {
              ...ep["subtitles"],
              [subs.language]: subs.subtitles,
            };
          }
        }
      }
    });
    sessionStorage.removeItem("subtitles_data");
    ep_data = ep_data.filter((e) => e.del_box === false);
    values = ep_data.concat(episodesData);
    console.log(values);
    let id = sessionStorage.getItem("content_id");
    if (id) {
      Put(
        `${apiUrl}/series/${id}`,
        token,
        { episodes: values, availability: availability },
        (result) => {
          if (result.success) {
            notification.success({
              message: "Success",
              description: "Episodes Updated",
            });
            setActiveKey("5");
            del_list = [];
            setRefresh(true);
          }
        }
      );
    }
  };

  const handleSubtitleUpload = (data) => {
    console.log(data);
  };

  useEffect(() => {
    console.log("refresh is now - ", refresh);
    if (refresh) {
      let id = sessionStorage.getItem("content_id");
      let data = { key: id };
      handleFetchSeries(data);
      setActiveTab("2");
      setRefresh(false);
      console.log("the series id is - ", id);
    }
  }, [refresh]);

  const handleAvailabilitySubmit = async () => {
    let geoAccess, avail;
    let valid = true;
    try {
      // geoAccess = await geoAccessForm.validateFields();
      avail = await availabilityForm.validateFields();

      if (listType === "allow") {
        for (const i in countryCodes) {
          if (geoAccess.countryMap.includes(i)) allowList.push(i);
        }
        console.log(allowList);
      }
      if (listType === "disallow") {
        for (const i in countryCodes) {
          if (!geoAccess.countryMap.includes(i)) allowList.push(i);
        }
        console.log(allowList);
      }
      if (listType === "allow_all") {
        for (const i in countryCodes) {
          allowList.push(i);
        }
      }
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Availability Form Error",
        description: "Required fields are incorrect/missing",
      });
      return;
    }
    if (avail.availability === "restricted") {
      if (startDate) {
        avail = {
          ...avail,
          startDate: startDate,
        };
        if (releaseDate) {
          if (releaseDate >= startDate) {
            notification.error({
              message: "Availability Form Error",
              description:
                "The start date should be later than the release date.",
            });
            return;
          }
        }
      }
    }
    let id = sessionStorage.getItem("content_id");
    if (id) {
      console.log("content_id - ", id);
      if (contentType === "movie") {
        Put(
          `${apiUrl}/movies/${id}`,
          token,
          {
            allowedCountries: allowList,
            listType: listType,
            ...avail,
          },
          (result) => {
            if (result.success === true) {
              notification.success({
                message: "Success",
                description: "Movie Saved",
              });
              handleReset();
              sessionStorage.removeItem("expandedRow");
            } else if (result.success === false) {
              const playlists = result.message.playlists;
              const promos = result.message.promos;
              if (playlists.length > 0 && promos.length > 0) {
                notification.error({
                  message: "Error updating content",
                  description: (
                    <>
                      {`Please delete from : `}
                      <div>{`- Playlists [${playlists.join(", ")}]`}</div>
                      <div>{`- Banner [Position : ${promos.join(", ")}]`}</div>
                      {`before updating the availability status`}
                    </>
                  ),
                });
              } else if (playlists.length > 0) {
                notification.error({
                  message: "Error updating content",
                  description: (
                    <>
                      {`Please delete from : `}
                      <div>{`- Playlists [${playlists.join(", ")}]`}</div>
                      {`before updating the availability status`}
                    </>
                  ),
                });
              } else if (promos.length > 0) {
                notification.error({
                  message: "Error updating content",
                  description: (
                    <>
                      {`Please delete from : `}
                      <div>{`- Banner [Position : ${promos.join(", ")}]`}</div>
                      {`before updating the availability status`}
                    </>
                  ),
                });
              }
            }
          }
        );
      }
    }
  };

  const handleSeriesAvailabilitySubmit = async (e) => {
    e.preventDefault();
    let geoAccess, avail;
    let valid = true;
    try {
      // geoAccess = await geoAccessForm.validateFields();
      avail = await availabilityForm.validateFields();
      for (const i in countryCodes) {
        allowList.push(i);
      }
      // if (listType === 'allow') {
      //     for (const i in countryCodes) {
      //         if (geoAccess.countryMap.includes(i)) allowList.push(i)
      //     }
      //     console.log(allowList)
      // }
      // if (listType === 'disallow') {
      //     for (const i in countryCodes) {
      //         if (!geoAccess.countryMap.includes(i)) allowList.push(i)
      //     }
      //     console.log(allowList)
      // }
      // if (listType === 'allow_all') {
      //     for (const i in countryCodes) {
      //         allowList.push(i)
      //     }
      // }
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Availability Form Error",
        description: "Required fields are incorrect/missing",
      });
      valid = false;
      return;
    }
    if (avail.availability === "restricted") {
      if (startDate) {
        avail = {
          ...avail,
          startDate: startDate,
        };
        if (releaseDate)
          if (releaseDate > startDate) {
            notification.error({
              message: "Availability Form Error",
              description:
                "The start date should be later than the release date.",
            });
            return;
          }
      }
    }
    let id = sessionStorage.getItem("content_id");
    if (id) {
      console.log("content_id - ", id);
      Put(
        `${apiUrl}/seasons/${seasonId}`,
        token,
        {
          allowedCountries: allowList,
          listType: listType,
          ...avail,
        },
        (result) => {
          if (result.success) {
            notification.success({
              message: "Success",
              description: "Season Saved",
            });
            handleReset();
            sessionStorage.removeItem("expandedRow");
          } else if (result.success === false) {
            const playlists = result.message.playlists;
            const promos = result.message.promos;
            if (playlists.length > 0 && promos.length > 0) {
              notification.error({
                message: "Error updating season",
                description: (
                  <>
                    {`Please delete from : `}
                    <div>{`- Playlists [${playlists.join(", ")}]`}</div>
                    <div>{`- Banner [Position : ${promos.join(", ")}]`}</div>
                    {`before updating the availability status`}
                  </>
                ),
              });
            } else if (playlists.length > 0) {
              notification.error({
                message: "Error updating season",
                description: (
                  <>
                    {`Please delete from : `}
                    <div>{`- Playlists [${playlists.join(", ")}]`}</div>
                    {`before updating the availability status`}
                  </>
                ),
              });
            } else if (promos.length > 0) {
              notification.error({
                message: "Error updating season",
                description: (
                  <>
                    {`Please delete from : `}
                    <div>{`- Banner [Position : ${promos.join(", ")}]`}</div>
                    {`before updating the availability status`}
                  </>
                ),
              });
            }
          }
        }
      );
    }
  };

  const handleReset = () => {
    sessionStorage.removeItem("content_id");
    console.log("active key - ", activeTab);
    setAddStandaloneContent(false);
    setAddSeriesContent(false);
    setShowTable(true);
    contentInfoForm.resetFields();
    seriesContentInfoForm.resetFields();
    castCrewAvailabilityForm.resetFields();
    seriesCastCrewAvailabilityForm.resetFields();
    videoAssetsForm.resetFields();
    episodesForm.resetFields();
    monetizationStreamingForm.resetFields();
    geoAccessForm.resetFields();
    availabilityForm.resetFields();
    seriesAvailabilityForm.resetFields();
    monetizationStreamingForm.resetFields();
    setRefreshMovies(true);
    setRefreshSeries(true);
    setStreamType("default");
    setCardImageUrl(null);
    setDetailImageUrl(null);
    setTrailerImageUrl(null);
    setLogoImageUrl(null);
    setTelugu(false);
    setHindi(false);
    setTamil(false);
    setCurrentEpisode(null);
    setSeasonId(null);
    setSeriesRecord(null);
  };

  const handleFetchMovie = (record) => {
    console.log(record);
    Fetch(`${apiUrl}/movies/${record.key}`, token, (result) => {
      if (result) {
        if (result.metaLanguage === "telugu") setTelugu(true);
        if (result.metaLanguage === "hindi") setHindi(true);
        if (result.metaLanguage === "tamil") setTamil(true);
        if (result.releaseDate) {
          result["releaseDate"] = dayjs(result.releaseDate);
          setReleaseDate(result["releaseDate"]);
        }
        if (result.startDate) {
          result["startDate"] = dayjs(record.startDate);
          setStartDate(result["startDate"]);
        }
        if (result.endDate) {
          result["endDate"] = dayjs(record.endDate);
          setEndDate(result["endDate"]);
        }
        setMovie(result);
        if (result.metaLanguages) {
          if (result.metaLanguages.includes("telugu")) setTelugu(true);
          if (result.metaLanguages.includes("hindi")) setHindi(true);
          if (result.metaLanguages.includes("tamil")) setTamil(true);
        }
        // if (result.teluguTitle || result.teluguDescription || result.metaLanguage === "telugu") setTelugu(true);
        // if (result.hindiTitle || result.hindiDescription || result.metaLanguage === "hindi") setHindi(true);
        // if (result.tamilTitle || result.tamilDescription || result.metaLanguage === "tamil") setTamil(true);
        sessionStorage.setItem("content_id", record.key);
        setShowTable(false);
        setAddStandaloneContent(true);
        if (result.cardImage) {
          setCardImageUrl(result.cardImage);
        }
        if (result.detailImage) {
          setDetailImageUrl(result.detailImage);
        }
        if (result.trailerImage) {
          setTrailerImageUrl(result.trailerImage);
        }
        if (result.logoImage) {
          setLogoImageUrl(result.logoImage);
        }
        if (result.streamType) {
          setStreamType(result.streamType);
        } else {
          setStreamType("default");
        }
        if (result.enable_subs) {
          setChecked(result.enable_subs);
        }
        videoAssetsForm.setFieldsValue(result);
        contentInfoForm.setFieldsValue(result);
        castCrewAvailabilityForm.setFieldsValue(result);
        availabilityForm.setFieldsValue(result);
        setAvailability(result.availability);
        let values = result.allowedCountries;
        if (result.listType) {
          setListType(result.listType);
          geoAccessForm.setFieldValue("listType", result.listType);
        } else {
          setListType("allow_all");
          geoAccessForm.setFieldValue("listType", "allow_all");
        }
        let countries = [];
        if (result.listType === "allow") {
          geoAccessForm.setFieldValue("countryMap", values);
        }
        if (result.listType === "disallow") {
          for (const i in countryCodes) {
            if (!values.includes(i)) {
              countries.push(i);
            }
          }
          geoAccessForm.setFieldValue("countryMap", countries);
          countries = [];
        }
      } else {
        notification.error({
          message: "Unauthorized",
          description: "Contact your admin for details",
        });
      }
    });
  };

  const seasonDown = async () => {
    if (season > 1) await setSeason(season - 1);
    else {
      notification.warning({
        message: "Invalid Season Number",
        description: "Cannot be Zero",
      });
      return;
    }
    let id = sessionStorage.getItem("content_id");
    let data = { key: id };
    setRefresh(true);
    await handleFetchSeries(data);
  };

  useEffect(() => {
    console.log("episodes for season ", season, " are ", episodesData);
  }, [episodesData]);

  const seasonUp = async () => {
    await setSeason(season + 1);
    let id = sessionStorage.getItem("content_id");
    let data = { key: id };
    setRefresh(true);
    await handleFetchSeries(data);
  };

  const getDisableStatus = (record) => {
    let status = false;
    let series_seasons = record.season_list;
    for (const i in series_seasons) {
      if (series_seasons[i] !== "unpublished" && superAdmin !== true) {
        status = true;
        break;
      }
    }
    return status;
  };

  const handleFetchSeries = (record) => {

    setRefresh(true);
    if (seriesRecord === undefined || seasonId === undefined || seasonId === null) {
      return;
    }
    seriesContentInfoForm.resetFields();
    seriesCastCrewAvailabilityForm.resetFields();
    seriesAvailabilityForm.resetFields();
    episodesForm.resetFields();
    Fetch(
      `${apiUrl}/seasons/${seriesRecord.key}/${seasonId}`,
      token,
      (result) => {
        if (result.success === true) {
          result = result.season;
          console.log("season data - ", result);
          if (result.metaLanguage === "telugu") setTelugu(true);
          if (result.metaLanguage === "hindi") setHindi(true);
          if (result.metaLanguage === "tamil") setTamil(true);
          if (result.releaseDate) {
            result["releaseDate"] = dayjs(result.releaseDate);
            setReleaseDate(result["releaseDate"]);
          }
          if (result.startDate) {
            result["startDate"] = dayjs(result.startDate);
            setStartDate(result["startDate"]);
          }
          if (result.endDate) {
            result["endDate"] = moment(result.endDate);
            setEndDate(result["endDate"]);
          }
          if (result.metaLanguages) {
            console.log(result.metaLanguages);
            if (result.metaLanguages.includes("telugu")) setTelugu(true);
            if (result.metaLanguages.includes("hindi")) setHindi(true);
            if (result.metaLanguages.includes("tamil")) setTamil(true);
          }
          // if (result.teluguTitle || result.teluguDescription || result.metaLanguage === "telugu") setTelugu(true);
          // if (result.hindiTitle || result.hindiDescription || result.metaLanguage === "hindi") setHindi(true);
          // if (result.tamilTitle || result.tamilDescription || result.metaLanguage === "tamil") setTamil(true);
          setSeriesId(result);
          sessionStorage.setItem("content_id", record.key);
          setContentType("series");
          setShowTable(false);
          setAddSeriesContent(true);
          if (result.cardImage) {
            setCardImageUrl(result.cardImage);
          }
          if (result.detailImage) {
            setDetailImageUrl(result.detailImage);
          }
          if (result.trailerImage) {
            setTrailerImageUrl(result.trailerImage);
          }
          if (result.logoImage) {
            setLogoImageUrl(result.logoImage);
          }
          seriesContentInfoForm.setFieldsValue(result);
          seriesCastCrewAvailabilityForm.setFieldsValue(result);
          availabilityForm.setFieldsValue(result);
          setAvailability(result.availability);
          setCurrentSeason(result.episodes);
          setCurrentEpisode(null);
          setShowOptionsModal(false);
          let values = result.allowedCountries;
          if (result.listType) {
            setListType(result.listType);
            geoAccessForm.setFieldValue("listType", result.listType);
          } else {
            setListType("allow_all");
            geoAccessForm.setFieldValue("listType", "allow_all");
          }
          let countries = [];
          if (result.listType === "allow") {
            geoAccessForm.setFieldValue("countryMap", values);
          }
          if (result.listType === "disallow") {
            for (const i in countryCodes) {
              if (!values.includes(i)) {
                countries.push(i);
              }
            }
            geoAccessForm.setFieldValue("countryMap", countries);
            countries = [];
          }
        }
      }
    );
  };

  const handleFetchSeason = () => {
    // setRefresh(true);
    console.log(seriesRecord);
    Fetch(
      `${apiUrl}/seasons/${seriesRecord.key}/${seasonId}`,
      token,
      (result) => { }
    );
  };

  const handleDeleteStandaloneContent = (record) => {
    console.log("the selected content is - ", record);
    Delete(`${apiUrl}/movies/${record.key}`, token, (result) => {
      if (result.success === true) {
        notification.success({
          message: "Deleted",
          description: "Content Deleted Successfully",
        });
        sessionStorage.removeItem("expandedRow");
        setRefreshMovies(true);
      } else if (result.success === false) {
        const playlists = result.playlists;
        const promos = result.promos;

        if (playlists.length > 0 && promos.length > 0) {
          notification.error({
            message: "Error deleting content",
            description: (
              <>
                {`Please delete from : `}
                <div>{`- Playlists [${playlists.join(", ")}]`}</div>
                <div>{`- Banner [Position : ${promos.join(", ")}]`}</div>
                {`before deleting the content`}
              </>
            ),
          });
        } else if (playlists.length > 0) {
          notification.error({
            message: "Error deleting content",
            description: (
              <>
                {`Please delete from : `}
                <div>{`- Playlists [${playlists.join(", ")}]`}</div>
                {`before deleting the content`}
              </>
            ),
          });
        } else if (promos.length > 0) {
          notification.error({
            message: "Error deleting content",
            description: (
              <>
                {`Please delete from : `}
                <div>{`- Banner [Position : ${promos.join(", ")}]`}</div>
                {`before deleting the content`}
              </>
            ),
          });
        }
      } else {
        notification.error({
          message: "Unauthorized",
          description: "Contact your admin for details",
        });
      }
    });
  };

  const handleDeleteSeriesContent = (record) => {
    console.log("the selected content is - ", record);
    Delete(`${apiUrl}/series/${record.key}`, token, (result) => {
      if (result.success) {
        notification.success({
          message: "Deleted",
          description: "Content Deleted Succesfully",
        });
        sessionStorage.removeItem("expandedRow");
        setRefreshSeries(true);
      } else if (result.success === false) {
        const playlists = result.message.playlists;
        const promos = result.message.promos;
        notification.error({
          message: "Error Deleting Series",
          description: (
            <>
              {playlists &&
                playlists.length > 0 &&
                Object.entries(playlists).map(([key, value]) => (
                  <>
                    <div>Please delete :</div>
                    {Object.entries(value).map(([k, v]) => (
                      <>{`- ${k} from playlists [${v.join(", ")}]`}</>
                    ))}
                  </>
                ))}
              {promos &&
                promos.length > 0 &&
                Object.entries(promos).map(([key, value]) => (
                  <>
                    <div>
                      {Object.entries(value).map(([k, v]) => (
                        <>{`- ${k} from banner position - [${v.join(", ")}]`}</>
                      ))}
                    </div>
                  </>
                ))}
            </>
          ),
          duration: 0,
        });
      } else {
        notification.error({
          message: "Unauthorized",
          description: "Contact your admin for details",
        });
      }
    });
  };

  const handleDeleteSeason = () => {
    if (!seasonId) {
      notification.info({
        message: "Something went wrong",
        description: "Please refresh and try again",
      });
      return;
    }

    Delete(`${apiUrl}/seasons/${seasonId}`, token, (result) => {
      if (result.success === true) {
        // setSpin(true)
        notification.success({
          message: "Success",
          description: "Deleted Season",
        });
        setRefreshSeries(true);
        handleReset();
        // setTimeout(() => {
        //     setSpin(false)
        // }, 100)
        setDeleteFlag(true);
      } else if (result.success === false) {
        const playlists = result.message.playlists;
        const promos = result.message.promos;

        if (playlists.length > 0 && promos.length > 0) {
          notification.error({
            message: "Error deleting season",
            description: (
              <>
                {`Please delete from : `}
                <div>{`- Playlists [${playlists.join(", ")}]`}</div>
                <div>{`- Banner [Position : ${promos.join(", ")}]`}</div>
                {`before deleting this season`}
              </>
            ),
          });
        } else if (playlists.length > 0) {
          notification.error({
            message: "Error deleting season",
            description: (
              <>
                {`Please delete from : `}
                <div>{`- Playlists [${playlists.join(", ")}]`}</div>
                {`before deleting this season`}
              </>
            ),
          });
        } else if (promos.length > 0) {
          notification.error({
            message: "Error deleting season",
            description: (
              <>
                {`Please delete from : `}
                <div>{`- Banner [Position : ${promos.join(", ")}]`}</div>
                {`before deleting this season`}
              </>
            ),
          });
        }
      } else {
        notification.error({
          message: "Error Deleting Season",
          description: result["message"],
        });
      }
    });
  };

  const handleStandAloneTitleSubmit = async () => {
    let values = await addStandloneTitleForm.validateFields();
    console.log("standalone title form values - ", values);

    Post(`${apiUrl}/movies`, token, { ...values }, (result) => {
      if (result.success === true) {
        sessionStorage.setItem("content_id", result.content_id);
        notification.success({
          message: "Success",
          description: "Title Added Successfully",
        });
        sessionStorage.removeItem("expandedRow");
        setShowModal(false);
        setAddStandaloneContent(true);
        setShowTable(false);
        setMovie(values);
        console.log(movie);
        addStandloneTitleForm.resetFields();
        contentInfoForm.setFieldsValue(values);
        handleFetchMovie({ key: result.content_id });
      } else if (result.success === false) {
        notification.error({
          message: "Error adding content",
          description: result["message"],
        });
      } else {
        notification.error({
          message: "Unauthorized",
          description: "Contact your admin for details",
        });
      }
    });
  };

  const handleSeriesTitleSubmit = async () => {
    let values = await addSeriesTitleForm.validateFields();

    if (seriesTitleModalType === "Edit") {
      Put(
        `${apiUrl}/series/${seriesRecord.key}`,
        token,
        { ...values },
        (result) => {
          setSeasonEpisodes([]); // making season episodes empty when user clicked on continue to remove old data
          if (result.success === true) {
            sessionStorage.removeItem("expandedRow");
            setSeriesTitleModal(false);
            setSeriesTitleModalType("Add");
            notification.success({
              message: "Success",
              description: "Series Updated Successfully",
            });
            addSeriesTitleForm.resetFields();
            setRefreshSeries(true);
          } else if (result.success === false) {
            notification.error({
              message: "Error Updating Series",
              description: result["message"],
            });
          } else {
            notification.error({
              message: "Something Went Wrong",
              description: "Check console for details",
            });
          }
        }
      );
      return;
    }

    Post(`${apiUrl}/series`, token, { ...values }, (result) => {
      if (result.success === true) {
        setSpin(true);
        sessionStorage.setItem("content_id", result.content_id);
        notification.success({
          message: "Success",
          description: "Series Added Successfully",
        });
        sessionStorage.removeItem("expandedRow");
        setSeriesTitleModal(false);
        setRefreshSeries(true);
        setTimeout(() => {
          setSpin(false);
        }, 100);
        addSeriesTitleForm.resetFields();
      } else if (result.success === false) {
        notification.error({
          message: "Error Updating Series",
          description: result["message"],
        });
      } else {
        notification.error({
          message: "Unauthorized",
          description: "Contact your admin for details",
        });
      }
    });
  };

  const playStandAloneContent = async () => {
    console.log("content being played");
  };

  const playSeriesContent = async () => {
    console.log("content being played");
  };

  const handleBreadCrumb = () => {
    setTitle(false);
    setMovie(null);
    setSeriesId(null);
    setShowTable(true);
  };

  const publishStandaloneContent = (record) => {
    console.log(record);
    Put(
      `${apiUrl}/movies/${record.key}`,
      token,
      {
        availability:
          record.availability === "unpublished" ? "perpetual" : "unpublished",
      },
      (result) => {
        notification.success({
          success: "Success",
          description: `Content ${record.availability === "unpublished" ? "Published" : "Unpublished"
            } successfully`,
        });
        setRefreshMovies(true);
      }
    );
  };

  const publishEpisodicContent = (record) => {
    console.log(record);
    Put(
      `${apiUrl}/series/${record.key}`,
      token,
      {
        availability:
          record.availability === "unpublished" ? "perpetual" : "unpublished",
      },
      (result) => {
        notification.success({
          success: "Success",
          description: `Content ${record.availability === "unpublished" ? "Published" : "Unpublished"
            } successfully`,
        });
        setRefreshSeries(true);
      }
    );
  };
  console.log("moviemoviemoviemovie", movie)
  const validateInputFields = (_, value) => {
    console.log("input validation - ", value);
    if (!value) {
      return Promise.reject(new Error("Missing mandatory field"));
    }
    if (/^\s/.test(value)) {
      return Promise.reject(new Error("Input cannot start with a space"));
    }
    // if (!(/^[a-zA-Z0-9\s\u0080-\uFFFF]*$/).test(value)) {
    //     return Promise.reject(new Error("Input can only contain alphabets, spaces and native language characters."))
    // }
    if (value.length < 3 || value.length > 255) {
      return Promise.reject(
        new Error("Input must be between 3-255 characters")
      );
    }
    return Promise.resolve();
  };
  const validateDescriptionFields = (_, value) => {
    console.log("input validation - ", value);
    if (!value) {
      return Promise.reject(new Error("Missing mandatory field"));
    }
    if (/^\s/.test(value)) {
      return Promise.reject(new Error("Input cannot start with a space"));
    }
    // if (!(/^[a-zA-Z0-9\s\u0080-\uFFFF]*$/).test(value)) {
    //     return Promise.reject(new Error("Input can only contain alphabets, spaces and native language characters."))
    // }
    if (value && value.length < 2) {
      return Promise.reject(
        new Error("Input must contain atleast 2 characters")
      );
    }
    return Promise.resolve();
  };

  const handleCreateSeason = (record) => {
    Post(
      `${apiUrl}/seasons/${record.key}/${record.seasons + 1}`,
      token,
      {},
      (result) => {
        if (result.success === true) {
          notification.success({
            message: "Success",
            description: "Season added successfully",
          });
          setShowOptionsModal(false);
          setRefreshSeries(true);
        } else {
          notification.error({
            message: "Error Adding Season",
            description: result["message"],
          });
        }
      }
    );
  };

  const handleCreateEpisode = async () => {
    let values = await episodeTItleForm.validateFields();

    Post(
      `${apiUrl}/episodes/${seasonId}`,
      token,
      {
        ...values,
      },
      (result) => {
        if (result.success === true) {
          setSpin(true);
          sessionStorage.removeItem("expandedRow");
          notification.success({
            message: "Episode Created",
            description: "Please update necessary fields for created episode",
          });
          setEpisodeModalVisible(false);
          // setActiveKey("4");
          setTimeout(() => {
            setSpin(false);
          }, 10);
          setRefresh(true);
          episodeTItleForm.resetFields();
        } else {
          notification.error({
            message: "Failed to Create",
            description: result["message"],
          });
        }
      }
    );
  };
  console.log("movie_______", movie)
  const mapSeasons = (record) => {
    setSeriesRecord(record);
    return (
      <Space size={"small"} direction="vertical">
        {record.season_list && record.season_list.length !== 0 ? (
          record.season_list.map((item) => (
            <Space size={"small"}>
              {item.availability === "perpetual" && (
                <Tooltip title="Published">
                  <CheckCircleFilled
                    style={{ marginLeft: "50px" }}
                    twoToneColor={"#4ef037"}
                  />
                </Tooltip>
              )}
              {item.availability === "unpublished" && (
                <Tooltip title="Unpublished">
                  <CloseCircleFilled
                    style={{ marginLeft: "50px" }}
                    twoToneColor={"red"}
                  />
                </Tooltip>
              )}
              {item.availability === "restricted" && (
                <Tooltip
                  title={`Available from ${dayjs(item.publish_date).format(
                    "YYYY-MM-DD HH:mm"
                  )}`}
                >
                  <InfoCircleTwoTone
                    style={{ marginLeft: "50px" }}
                    twoToneColor={"orange"}
                  />
                </Tooltip>
              )}
              <Button
                type="link"
                block={true}
                ghost={true}
                disabled={
                  superAdmin !== true && item.availability !== "unpublished"
                }
                onClick={() => {
                  setSeasonId(item._id);
                  handleFetchSeries(record);
                }}
                style={{
                  marginLeft: "0px",
                  border: "none",
                  marginTop: "0px",
                  marginBottom: "0px",
                }}
              >
                {item.season}
              </Button>
            </Space>
          ))
        ) : (
          <Space align="center" style={{ marginLeft: "50px" }}>
            <WarningFilled /> No Seasons Found
          </Space>
        )}
      </Space>
    );
  };

  const handleSeriesSearchChange = (record) => {
    if (!record.key) {
      return;
    }
    sessionStorage.removeItem("expandedRow");
    for (const a in seriesMaster) {
      if (seriesMaster[a].key === record.key) {
        setSeries([seriesMaster[a]]);
        break;
      }
    }
  };

  const handleMoviesSearchChange = (record) => {
    if (!record.key) {
      return;
    }
    sessionStorage.removeItem("expandedRow");
    for (const a in moviesMaster) {
      if (moviesMaster[a].key === record.key) {
        setMovies([moviesMaster[a]]);
        break;
      }
    }
  };

  return (
    <>
      {spin ? (
        <Spin className="loading-container" size="large" />
      ) : (
        <div className="add-content-wrapper">
          {!addStandaloneContent && !addSeriesContent ? (
            <>
              {/* <Col span={'100%'} style={{ marginBottom: '20px' }}>
                          </Col> */}
              <Row
                style={{
                  backgroundColor: "#fff",
                  padding: "10px 20px 10px 10px",
                  borderBottom: "1px solid #eee",
                }}
              >
                <Col span={"80%"}>
                  <Title level={4} align="left">
                    Manage Content
                  </Title>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Tabs
                    activeKey={activeTab}
                    onChange={(tab) => {
                      console.log("tab - ", tab, typeof tab);
                      setActiveTab(tab);
                      setSaved(false);
                      setShowTable(true);
                      standAloneForm.resetFields();
                      titleForm.resetFields();
                      setTitle(false);
                      console.log(contentType);
                      setFilter("all");
                      setActiveKey("1");
                      setCurrentEpisode(null);
                      sessionStorage.removeItem("expandedRow");
                    }}
                    className="add-content-tabs addContentTabs"
                  >
                    <TabPane
                      tab={
                        <div onClick={()=> setContentType("movie")}>
                          <div className="tabMainTitle">Standalone</div>
                          <span className="tabSubTitle">
                            Singlepart Content
                          </span>
                        </div>
                      }
                      key="1"
                    >
                      {showTable && (
                        <>
                          <Row>
                            <Select
                              placeholder="Search Content"
                              showSearch
                              allowClear
                              onChange={(_, record) => {
                                handleMoviesSearchChange(record);
                                // handleFetchMovie(record);
                              }}
                              onClear={() => {
                                setFilter("all");
                                setMovies(moviesMaster);
                              }}
                              style={{ width: "100%", marginBottom: "15px" }}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {moviesMaster.map((m) => (
                                <Option key={m.key} value={m.title}>
                                  {m.title}
                                </Option>
                              ))}
                            </Select>
                          </Row>
                          <Row
                            justify={"space-between"}
                            style={{ marginBottom: "25px" }}
                          >
                            <Col>
                              {!showModal && (
                                <Button
                                  className="title-btn"
                                  type="primary"
                                  onClick={() => {
                                    /* setShowTable(false);
                                                                      handleTitleUpdate();
                                                                      setShowTitle(true); */
                                    setShowModal(true);
                                  }}
                                >
                                  Add Title
                                </Button>
                              )}
                            </Col>
                            <Col>
                              <Select
                                defaultValue="all"
                                style={{ width: 120 }}
                                onChange={(value) => {
                                  setFilter(value);
                                }}
                                value={filter}
                                options={[
                                  { value: "all", label: "View All" },
                                  { value: "draft", label: "Unpublished" },
                                  { value: "restricted", label: "Restricted" },
                                  { value: "published", label: "Published" },
                                ]}
                              />
                            </Col>
                          </Row>

                          <Table
                            dataSource={movies}
                            size="small"
                            pagination={false}
                            virtual
                            scroll={{
                              x: "max-content",
                              y: 500,
                            }}
                          // style={{ tableLayout: "auto", width: "100%" }}
                          >
                            <Column
                              title="Title"
                              dataIndex="title"
                              key="title"
                              align="left"
                              width={"100px"}
                              // paddingLeft={"3%"}
                              render={(_, record) => {
                                if (record.title.length > 50) {
                                  return (
                                    <Tooltip title={record.title}>
                                      <span>{`${record.title.slice(
                                        0,
                                        50
                                      )}...`}</span>
                                    </Tooltip>
                                  );
                                }
                                return <span>{record.title}</span>;
                              }}
                            />
                            <Column
                              title="Duration"
                              dataIndex={"duration"}
                              key="duration"
                              align="center"
                              render={(_, record) =>
                                record.duration ? record.duration : "--:--:--"
                              }
                            />
                            <Column
                              title="Status"
                              dataIndex="status"
                              key="status"
                              align="center"
                              render={(_, record) => {
                                return (
                                  <div>
                                    {record.status === "Published" && (
                                      <Tag color="green">{record.status}</Tag>
                                    )}
                                    {record.status === "Unpublished" && (
                                      <Tag color="red">{record.status}</Tag>
                                    )}
                                    {record.status === "restricted" && (
                                      <>
                                        <Tag color="orange">Restricted</Tag>
                                        <Tooltip
                                          title={`Available from ${dayjs(
                                            record.startDate
                                          ).format("YYYY-MM-DD HH:mm")}`}
                                        >
                                          <InfoCircleOutlined />
                                        </Tooltip>
                                      </>
                                    )}
                                  </div>
                                );
                              }}
                            />
                            <Column
                              title="Created at"
                              dataIndex={"createdAt"}
                              key="createdAt"
                              align="center"
                              render={(_, record) =>
                                record.createdAt ? record.createdAt : "-"
                              }
                            />
                            <Column
                              title="Action"
                              align="center"
                              render={(_, record) => (
                                <Space align="center">
                                  <Tooltip title="Play">
                                    {/* <Button onClick={() => { playStandAloneContent(record) }} ><PlaySquareFilled /></Button> */}
                                  </Tooltip>
                                  <Tooltip title="Edit Content">
                                    <Button
                                      onClick={() => {
                                        handleFetchMovie(record);
                                        setMovieName(record.title);
                                      }}
                                      disabled={
                                        superAdmin !== true &&
                                        record.availability !== "unpublished"
                                      }
                                    >
                                      <EditFilled />
                                    </Button>
                                  </Tooltip>
                                  <Tooltip title="Preview">
                                    <Button
                                      onClick={() => {
                                        if (record.playbackUrl) {
                                          navigator.clipboard.writeText(
                                            record.playbackUrl
                                          );
                                          message.success(
                                            "Playback URL copied to clip board"
                                          );
                                        }
                                      }}
                                    >
                                      <PlaySquareFilled />
                                    </Button>
                                  </Tooltip>
                                  <Tooltip title="Delete Content">
                                    <Button
                                      danger
                                      type="primary"
                                      disabled={
                                        superAdmin !== true &&
                                        record.availability !== "unpublished"
                                      }
                                      onClick={() => {
                                        confirm({
                                          title:
                                            "Are you sure you want to delete this Content?",
                                          icon: <ExclamationCircleOutlined />,
                                          okText: "Yes",
                                          okType: "primary",
                                          okButtonProps: { danger: true },
                                          cancelText: "No",
                                          onOk() {
                                            handleDeleteStandaloneContent(
                                              record
                                            );
                                          },
                                        });
                                      }}
                                    >
                                      <DeleteFilled />
                                    </Button>
                                  </Tooltip>
                                </Space>
                              )}
                            ></Column>
                          </Table>
                        </>
                      )}
                    </TabPane>
                    <TabPane
                      tab={
                        <div onClick={()=> setContentType("series")}>
                          <div className="tabMainTitle">Episodic</div>
                          <span className="tabSubTitle">Multipart Content</span>
                        </div>
                      }
                      key={2}
                    >
                      {showTable && (
                        <>
                          <Row>
                            <Select
                              placeholder="Search Content"
                              showSearch
                              allowClear
                              onChange={(_, record) => {
                                console.log("record - ", record);
                                handleSeriesSearchChange(record);
                                // handleFetchSeries(record);
                              }}
                              onClear={() => {
                                setFilter("all");
                                setSeries(seriesMaster);
                              }}
                              style={{
                                width: "100%",
                                marginBottom: "15px",
                              }}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {seriesMaster.map((m) => (
                                <Option key={m.key} value={m.title}>
                                  {m.title}
                                </Option>
                              ))}
                            </Select>
                          </Row>
                          <Row
                            justify={"space-between"}
                            style={{ marginBottom: "25px" }}
                          >
                            <Col>
                              {!showModal && (
                                <Button
                                  className="title-btn"
                                  type="primary"
                                  onClick={() => {
                                    setSeriesTitleModal(true);
                                    console.log(
                                      "series title modal is - ",
                                      seriesTitleModal
                                    );
                                  }}
                                >
                                  Add Title
                                </Button>
                              )}
                            </Col>
                            <Col></Col>
                          </Row>
                          <Table
                            size="small"
                            dataSource={series}
                            pagination={false}
                            virtual
                            scroll={{
                              x: 1000,
                              y: 500,
                            }}
                            expandable={{
                              expandedRowRender: (record) => mapSeasons(record),
                              expandIcon: ({ expanded, onExpand, record }) =>
                                expanded ? (
                                  <Tooltip title="Click to Collapse seasons">
                                    <DownOutlined
                                      onClick={(e) => {
                                        onExpand(record, e);
                                        sessionStorage.removeItem(
                                          "expandedRow"
                                        );
                                        setExpandedRow(null);
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Click to Expand seasons">
                                    <RightOutlined
                                      onClick={(e) => {
                                        onExpand(record, e);
                                        sessionStorage.setItem(
                                          "expandedRow",
                                          record.key
                                        );
                                      }}
                                    />
                                  </Tooltip>
                                ),
                              defaultExpandedRowKeys: [
                                sessionStorage.getItem("expandedRow"),
                              ],
                            }}
                          >
                            <Column
                              title="Title"
                              dataIndex="title"
                              key="title"
                              paddingLeft={"3%"}
                              width={"30%"}
                              defaultSortOrder={"ascend"}
                              ellipsis={true}
                              render={(_, record) => {
                                if (record.title.length > 50) {
                                  return (
                                    <Tooltip title={record.title}>
                                      <span>{`${record.title.slice(
                                        0,
                                        50
                                      )}...`}</span>
                                    </Tooltip>
                                  );
                                }
                                return <span>{record.title}</span>;
                              }}
                            />
                            <Column
                              title="Seasons"
                              align="center"
                              render={(_, record) =>
                                record.seasons ? `${record.seasons}` : "-"
                              }
                            />
                            <Column
                              title="Episodes"
                              align="center"
                              render={(_, record) =>
                                record.episodes ? record.episodes : "-"
                              }
                            />
                            <Column
                              title="Created at"
                              dataIndex={"createdAt"}
                              key="createdAt"
                              width={"20%"}
                              align="center"
                              render={(_, record) =>
                                record.createdAt ? record.createdAt : "-"
                              }
                            />
                            <Column
                              width={"20%"}
                              title="Action"
                              align="center"
                              render={(_, record) => (
                                <Space align="center">
                                  {/* <Button onClick={() => { playSeriesContent(record) }}><PlaySquareFilled /></Button> */}
                                  {getDisableStatus(record) ? (
                                    <Tooltip title="Edit Series">
                                      <Button
                                        disabled={true}
                                        onClick={() => {
                                          sessionStorage.setItem(
                                            "content_id",
                                            record.key
                                          );
                                          // handleFetchSeries(record);
                                          setSeriesRecord(record);
                                          console.log(record);
                                          // setShowOptionsModal(true);
                                          addSeriesTitleForm.setFieldsValue(
                                            record
                                          );
                                          setSeriesTitleModalType("Edit");
                                          setSeriesTitleModal(true);
                                        }}
                                      >
                                        <EditFilled />
                                      </Button>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="Edit Series">
                                      <Button
                                        disabled={false}
                                        onClick={() => {
                                          sessionStorage.setItem(
                                            "content_id",
                                            record.key
                                          );
                                          // handleFetchSeries(record);
                                          setSeriesRecord(record);
                                          console.log(record);
                                          // setShowOptionsModal(true);
                                          addSeriesTitleForm.setFieldsValue(
                                            record
                                          );
                                          getSeasonEpisodes(record); // calling this function to fetch that particular series data to show for gating and ungating
                                          setSeriesTitleModalType("Edit");
                                          setSeriesTitleModal(true);
                                        }}
                                      >
                                        <EditFilled />
                                      </Button>
                                    </Tooltip>
                                  )}

                                  <Tooltip title="Add Season">
                                    <Button
                                      onClick={() => {
                                        console.log("clicked on add season");
                                        setSeriesRecord(record);
                                        console.log(
                                          "record before add season - ",
                                          record
                                        );
                                        handleCreateSeason(record);
                                      }}
                                    >
                                      <PlusSquareOutlined />
                                    </Button>
                                  </Tooltip>
                                  {getDisableStatus(record) ? (
                                    <Tooltip title="Delete Series">
                                      <Button
                                        disabled={true}
                                        onClick={() => {
                                          confirm({
                                            title:
                                              "Are you sure you want to delete this series?",
                                            icon: <ExclamationCircleOutlined />,
                                            content:
                                              "All the associated seasons and their episodes will also be erased if this series is deleted.",
                                            okText: "Yes",
                                            okType: "primary",
                                            okButtonProps: { danger: true },
                                            cancelText: "No",
                                            onOk() {
                                              handleDeleteSeriesContent(record);
                                            },
                                          });
                                        }}
                                        danger
                                        type="primary"
                                      >
                                        <DeleteFilled />
                                      </Button>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="Delete Series">
                                      <Button
                                        disabled={false}
                                        onClick={() => {
                                          confirm({
                                            title:
                                              "Are you sure you want to delete this series?",
                                            icon: <ExclamationCircleOutlined />,
                                            content:
                                              "All the associated seasons and their episodes will also be erased if this series is deleted.",
                                            okText: "Yes",
                                            okType: "primary",
                                            okButtonProps: { danger: true },
                                            cancelText: "No",
                                            onOk() {
                                              handleDeleteSeriesContent(record);
                                            },
                                          });
                                        }}
                                        danger
                                        type="primary"
                                      >
                                        <DeleteFilled />
                                      </Button>
                                    </Tooltip>
                                  )}
                                </Space>
                              )}
                            ></Column>
                          </Table>
                        </>
                      )}
                    </TabPane>
                  </Tabs>
                </Col>
              </Row>
            </>
          ) : (
            ""
          )}
          {/* Adding detail content of Standalone */}

          {addStandaloneContent && (
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={24} style={{ marginBottom: "20px" }}>
                    <Breadcrumb
                      items={[
                        {
                          title: <a onClick={handleReset}> Manage Content </a>,
                        },
                        {
                          title:
                            movie.title.length > 50 ? (
                              <a href="#">
                                <span>{`${movie.title.slice(0, 50)}...`}</span>
                              </a>
                            ) : (
                              movie.title
                            ),
                        },
                      ]}
                    />
                    <Title level={3} style={{ marginBottom: "10px" }}>
                      {movie.title.length > 50 ? (
                        <span>{`${movie.title.slice(0, 50)}...`}</span>
                      ) : (
                        movie.title
                      )}
                    </Title>
                    <Text type="secondary">
                      <>
                        <Tag
                          color="blue"
                          style={{
                            borderRadius: "100px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                        >
                          English
                        </Tag>
                        {Telugu && (
                          <Tag
                            color="blue"
                            style={{
                              borderRadius: "100px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            Spanish
                          </Tag>
                        )}
                        {Hindi && (
                          <Tag
                            color="blue"
                            style={{
                              borderRadius: "100px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            German
                          </Tag>
                        )}
                        {Tamil && (
                          <Tag
                            color="blue"
                            style={{
                              borderRadius: "100px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            French
                          </Tag>
                        )}
                      </>
                      <Popover
                        content={addLanguagePopover}
                        trigger="click"
                        placement="bottom"
                        title="Add a Language"
                      >
                        <Button
                          size="small"
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "10px",
                          }}
                        >
                          Add
                        </Button>
                      </Popover>
                    </Text>
                  </Col>
                </Row>
              </Col>
              <Col span={24} style={{ marginTop: "15px" }}>
                <Tabs
                  activeKey={activeKey}
                  className="add-content-tabs addContentTabs"
                  onChange={setActiveKey}
                >
                  <TabPane tab={<label>Catalog Listing</label>} key="1">
                    <Form layout="vertical" form={contentInfoForm}>
                      <Row gutter={30}>
                        <Col span={12}>
                          <Form.Item
                            name={"title"}
                            label="Title"
                            rules={[
                              {
                                required: true,
                                validator: validateInputFields,
                              },
                            ]}
                            extra="English"
                          >
                            <Input
                              placeholder="Enter title here..."
                              value={movie.title}
                              maxLength={255}
                              showCount
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name={"category"}
                            label="Category"
                            rules={[{ required: true }]}
                          >
                            <Select
                              defaultValue="movie"
                              onChange={setContentType}
                              placeholder="Select a category"
                              disabled={true}
                              value={movie.category}
                            >
                              <Option value="movie">Movie</Option>
                              <Option value="song">Song</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      {Telugu && (
                        <Row gutter={30}>
                          <Col span={12}>
                            <Form.Item
                              name={"teluguTitle"}
                              label="Title"
                              rules={[
                                {
                                  required: true,
                                  validator: validateInputFields,
                                },
                              ]}
                              extra="Spanish"
                            >
                              <Input
                                placeholder="Enter title here..."
                                value={movie.TeluguTitle}
                                maxLength={255}
                                showCount
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      {Hindi && (
                        <Row gutter={30}>
                          <Col span={12}>
                            <Form.Item
                              name={"hindiTitle"}
                              label="Title"
                              rules={[
                                {
                                  required: true,
                                  validator: validateInputFields,
                                },
                              ]}
                              extra="German"
                            >
                              <Input
                                placeholder="Enter title here..."
                                value={movie.HindiTitle}
                                maxLength={255}
                                showCount
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      {Tamil && (
                        <Row gutter={30}>
                          <Col span={12}>
                            <Form.Item
                              name={"tamilTitle"}
                              label="Title"
                              rules={[
                                {
                                  required: true,
                                  validator: validateInputFields,
                                },
                              ]}
                              extra="French"
                            >
                              <Input
                                placeholder="Enter title here..."
                                value={movie.TamilTitle}
                                maxLength={255}
                                showCount
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      <Divider style={{ marginTop: 0 }} />
                      <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"description"}
                            dataIndex={"description"}
                            label="Synopsis (English)"
                            rules={[
                              {
                                required: true,
                                validator: validateDescriptionFields,
                              },
                            ]}
                          >
                            <TextArea
                              rows={4}
                              placeholder="Enter short description of the movie"
                              showCount
                              maxLength={1000}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      {Telugu && (
                        <Row gutter={30}>
                          <Col span={24}>
                            <Form.Item
                              name={"teluguDescription"}
                              dataIndex={"germanDescription"}
                              label="Synopsis (Spanish)"
                              rules={[
                                {
                                  required: true,
                                  validator: validateDescriptionFields,
                                },
                              ]}
                            >
                              <TextArea
                                rows={4}
                                placeholder="Enter short description of the movie"
                                showCount
                                maxLength={1000}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      {Hindi && (
                        <Row gutter={30}>
                          <Col span={24}>
                            <Form.Item
                              name={"hindiDescription"}
                              dataIndex={"HindiDescription"}
                              label="Synopsis (German)"
                              rules={[
                                {
                                  required: true,
                                  validator: validateDescriptionFields,
                                },
                              ]}
                            >
                              <TextArea
                                rows={4}
                                placeholder="Enter short description of the movie"
                                showCount
                                maxLength={1000}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      {Tamil && (
                        <Row gutter={30}>
                          <Col span={24}>
                            <Form.Item
                              name={"tamilDescription"}
                              dataIndex={"TamilDescription"}
                              label="Synopsis (French)"
                              rules={[
                                {
                                  required: true,
                                  validator: validateDescriptionFields,
                                },
                              ]}
                            >
                              <TextArea
                                rows={4}
                                placeholder="Enter short description of the movie"
                                showCount
                                maxLength={1000}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"genre"}
                            dataIndex={"genre"}
                            label="Themes"
                            rules={[{ required: true }]}
                          >
                            <Select
                              mode="multiple"
                              placeholder="Select a theme"
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {genres &&
                                genres.map((genre) => (
                                  <Option key={genre.name} value={genre._id}>
                                    {genre.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={30}>
                        <Col span={12}>
                          <Form.Item
                            name={"slug"}
                            rules={[
                              {
                                required: true,
                                pattern: /^[a-zA-Z0-9-]*$/,
                                message:
                                  "Slug must be alphanumeric value separated with '-'",
                              },
                            ]}
                            label="Slug"
                          >
                            <Input disabled={movie.slug} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="releaseDate"
                            label="Publish Date"
                            rules={[{ required: true }]}
                          >
                            <DatePicker
                              style={{ width: "100%" }}
                              onChange={(_, datestring) =>
                                setReleaseDate(dayjs(datestring))
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      {/* <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"originCountry"}
                            dataIndex={"originCountry"}
                            label="Country/Region of origin"
                            rules={[{ required: true }]}
                            extra="The order of countries/regions is important, with the first entry corresponding to the production company with the greatest contribution to the title."
                          >
                            <Select placeholder={"Select a country"} showSearch>
                              {Object.entries(countryCodes).map(
                                ([code, name]) => (
                                  <Option key={name} value={code}>
                                    {name}
                                  </Option>
                                )
                              )}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row> */}
                      <Row gutter={30}>
                        {/* <Col span={12}>
                          <Form.Item
                            name={"language"}
                            label="Original language"
                          >
                            <Select
                              placeholder="Select a language"
                              mode="multiple"
                              showSearch
                            >
                              {languages &&
                                languages.map((language) => (
                                  <Option value={language.name}>
                                    {language.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col> */}
                        {/* <Col span={12}>
                          <Form.Item
                            name="releaseDate"
                            label="Publish Date"
                            rules={[{ required: true }]}
                          >
                            <DatePicker
                              style={{ width: "100%" }}
                              onChange={(_, datestring) =>
                                setReleaseDate(dayjs(datestring))
                              }
                            />
                          </Form.Item>
                        </Col> */}
                      </Row>
                      <Divider style={{ marginTop: 0 }} />
                      <Row>
                        <Col>
                          <Title level={5}>Graphic assets </Title>
                          <Text>
                            Key art (also known as cover or the title art)
                            represents your title on Prime Video.{" "}
                            <strong>
                              Please include legible titles on your key art.
                            </strong>{" "}
                            The background image adds visual interests to video
                            detail pages.
                          </Text>
                        </Col>
                      </Row>
                      <div style={{ marginLeft: "10%", marginRight: "10%" }}>
                        <Row
                          gutter={30}
                          style={{ marginTop: "20px" }}
                          justify={"center"}
                        >
                          {/* 16:9 Image */}
                          <Col span="8">
                            <Row>
                              <Col span={24}>
                                <Text>
                                  <strong>
                                    <font color="red">*</font>Key art
                                  </strong>{" "}
                                  (16:9){" "}
                                </Text>
                              </Col>
                              <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                                <Form.Item
                                  name={"detailImage"}
                                  rules={[{ required: true }]}
                                >
                                  <Upload
                                    showUploadList={false}
                                    action={`${apiUrl}/uploads/fastpixUploads`}
                                    headers={{
                                      authorization: `Bearer ${token}`,
                                    }}
                                    beforeUpload={beforeImageUpload}
                                    onChange={
                                      handleDetailImageUploadStatusChange
                                    }
                                  >
                                    <Button size="small">Browse...</Button>
                                  </Upload>
                                </Form.Item>{" "}
                              </Col>
                              <Col span={24}>
                                {detailImageUrl ? (
                                  <Image
                                    style={{
                                      aspectRatio: "16/9",
                                      objectFit: "contain",
                                    }}
                                    src={detailImageUrl}
                                  />
                                ) : (
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                )}
                              </Col>
                            </Row>
                          </Col>
                          <Col span={8}> </Col>
                          {/* 3:4 Image */}
                          <Col span="8">
                            <Row>
                              <Col span={24}>
                                <Text>
                                  <strong>
                                    <font color="red">*</font>Key art
                                  </strong>{" "}
                                  (3:4){" "}
                                </Text>
                              </Col>
                              <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                                <Form.Item
                                  name={"cardImage"}
                                  rules={[{ required: true }]}
                                >
                                  <Upload
                                    showUploadList={false}
                                    action={`${apiUrl}/uploads/fastpixUploads`}
                                    headers={{
                                      authorization: `Bearer ${token}`,
                                    }}
                                    beforeUpload={beforeImageUpload}
                                    onChange={handleCardImageUploadStatusChange}
                                  >
                                    <Button size="small">Browse...</Button>
                                  </Upload>
                                </Form.Item>
                                {/* <Button size="small">Google Drive</Button> */}
                              </Col>
                              <Col span={24}>
                                {cardImageUrl ? (
                                  <Image
                                    style={{
                                      aspectRatio: "16/9",
                                      objectFit: "contain",
                                    }}
                                    src={cardImageUrl}
                                  />
                                ) : (
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Divider style={{ margin: "10px 2" }} />
                        </Row>
                        <Row
                          gutter={30}
                          style={{ marginTop: "20px" }}
                          justify={"center"}
                        >
                          {/* Logo Image */}
                          <Col span="8">
                            <Row>
                              <Col span={24}>
                                <Text>
                                  <strong>Logo Image (16:9)</strong> (Optional){" "}
                                </Text>
                              </Col>
                              <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                                <Form.Item
                                  name={"logoImage"}
                                  rules={[{ required: false }]}
                                >
                                  <Upload
                                    showUploadList={false}
                                    action={`${apiUrl}/uploads/fastpixUploads`}
                                    headers={{
                                      authorization: `Bearer ${token}`,
                                    }}
                                    beforeUpload={beforeImageUpload}
                                    onChange={handleLogoImageUploadStatusChange}
                                  >
                                    <Button size="small">Browse...</Button>
                                  </Upload>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                {logoImageUrl ? (
                                  <Image
                                    style={{
                                      aspectRatio: "16/9",
                                      objectFit: "contain",
                                    }}
                                    src={logoImageUrl}
                                  />
                                ) : (
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                )}
                              </Col>
                            </Row>
                          </Col>
                          <Col span={8}> </Col>
                          {/* Background Image */}
                          <Col span="8">
                            <Row>
                              <Col span={24}>
                                <Text>
                                  <strong>
                                    <font color="red">*</font>Background Image
                                    (21:9)
                                  </strong>{" "}
                                </Text>
                              </Col>
                              <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                                <Form.Item
                                  name={"trailerImage"}
                                  rules={[{ required: true }]}
                                >
                                  <Upload
                                    showUploadList={false}
                                    action={`${apiUrl}/uploads/fastpixUploads`}
                                    headers={{
                                      authorization: `Bearer ${token}`,
                                    }}
                                    beforeUpload={beforeImageUpload}
                                    onChange={
                                      handleTrailerImageUploadStatusChange
                                    }
                                  >
                                    <Button size="small">Browse...</Button>
                                  </Upload>
                                </Form.Item>
                                {/* <Button size="small">Google Drive</Button> */}
                              </Col>
                              <Col span={24}>
                                {trailerImageUrl ? (
                                  <Image
                                    style={{
                                      aspectRatio: "16/9",
                                      objectFit: "contain",
                                    }}
                                    src={trailerImageUrl}
                                  />
                                ) : (
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                      <Divider style={{ margin: "5px 0" }} />
                      <Row justify="end" style={{ marginTop: "50px" }}>
                        <Col span={24} style={{ textAlign: "right" }}>
                          <Button
                            type="primary"
                            style={{ padding: "0 20px" }}
                            onClick={handleContentInfoSubmit}
                          >
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  <TabPane tab="Cast & Crew" key="2">
                    <Form layout="vertical" form={castCrewAvailabilityForm}>
                      <Row gutter={30}>
                        <Col span={24}>
                          <Title level={4}>
                            Creator{" "}
                            <font color="red" size="small">
                              *
                            </font>
                          </Title>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name={"creator"}
                            rules={[{ required: true }]}
                          >
                            <Select
                              mode="single"
                              placeholder="Select a creator"
                              style={{ width: "100%" }}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {creators &&
                                creators.map((c) => (
                                  <Option key={c.name} value={c._id}>
                                    {c.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Divider />
                      <Row gutter={30}>
                        <Col span={24}>
                          <Title level={4}>
                            {" "}
                            Host{" "}
                            <font color="red" size="small">
                              *
                            </font>
                          </Title>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="hosts"
                            label=""
                            rules={[{ required: true }]}
                          >
                            <Select
                              placeholder="Select host Name here..."
                              showSearch
                              mode="multiple"
                              value={movie.hosts ? movie.hosts : null}
                              rules={[{ required: true }]}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {hosts &&
                                hosts.map((studio) => (
                                  <Option key={studio.name} value={studio._id}>
                                    {studio.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}></Col>
                      </Row>
                      <Divider style={{ marginTop: 0 }} />
                      <Row>
                        <Col span={24}>
                          <Title level={4}> Guests</Title>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="guests"
                            label=""
                            rules={[{ required: false }]}
                          >
                            <Select
                              placeholder="Select guests here..."
                              showSearch
                              mode="multiple"
                              value={movie.guests ? movie.guests : null}
                              rules={[{ required: true }]}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {guests &&
                                guests.map((studio) => (
                                  <Option key={studio.name} value={studio._id}>
                                    {studio.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={24} style={{ marginTop: "15px" }}>
                          <Row>
                            <Col span={24}>
                              <Title level={4}> Technical Help</Title>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                name="tech"
                                label=""
                                rules={[{ required: false }]}
                              >
                                <Select
                                  placeholder="Select tech help members here..."
                                  showSearch
                                  mode="multiple"
                                  value={movie.tech ? movie.tech : null}
                                  rules={[{ required: true }]}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                  filterSort={(optionA, optionB) =>
                                    optionA.children
                                      .toLowerCase()
                                      .localeCompare(
                                        optionB.children.toLowerCase()
                                      )
                                  }
                                >
                                  {tech &&
                                    tech.map((studio) => (
                                      <Option
                                        key={studio.name}
                                        value={studio._id}
                                      >
                                        {studio.name}
                                      </Option>
                                    ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={30}></Row>
                        </Col>
                        <Col span={24}>
                          <Divider />
                        </Col>
                      </Row>
                      <Row justify="end">
                        <Col span={24} style={{ textAlign: "right" }}>
                          <Button
                            type="primary"
                            style={{ padding: "0 20px" }}
                            onClick={handleCastCrewSubmit}
                          >
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  <TabPane tab="Video assets" key="3">
                    <Form layout="vertical" form={videoAssetsForm}>
                      <Row gutter={30}>
                        <Col span={24}>
                          {streamType === "default" && (
                            <Title level={4}>
                              Video and Audio Files{" "}
                              <span style={{ fontSize: "15px" }}></span>
                            </Title>
                          )}
                        </Col>
                      </Row>

                      {streamType === "default" && (
                        // <Row>
                        //   <Col span={24}>
                        //     <Row gutter={30}>
                        //       <Col span={6}>Main Content</Col>
                        //       {/* <Col span={6}>
                        //         {"playbackUrl" in movie ? (
                        //           <Tag color="green" style={{ fontSize: 16 }}>
                        //             Content Exists
                        //           </Tag>
                        //         ) : null}
                        //         {"mp4PlaybackUrl" in movie ? (
                        //           <a
                        //             href={movie.mp4PlaybackUrl}
                        //             target="_blank"
                        //           >
                        //             <DownloadOutlined
                        //               style={{
                        //                 fontSize: "20px",
                        //               }}
                        //             />
                        //           </a>
                        //         ) : null}
                        //       </Col> */}
                        //       <Col span={6}>
                        //         {/* <UploadVideo
                        //           id={sessionStorage.getItem("content_id")}
                        //           upload={{
                        //             ...upload,
                        //             _id: sessionStorage.getItem("content_id"),
                        //             type: "movies",
                        //             episode: null,
                        //             season: null,
                        //           }}
                        //           activeObj={movie}
                        //         /> */}

                        //       </Col>
                        //     </Row>
                        //     <Row gutter={30} style={{ marginTop: "20px" }}>
                        //       <Col span={6}>Trailer (optional)</Col>
                        //       <Col span={6}>
                        //         {"trailer" in movie ? (
                        //           <Tag color="green" style={{ fontSize: 16 }}>
                        //             Trailer Exists
                        //           </Tag>
                        //         ) : null}
                        //       </Col>
                        //       <Col span={6}>
                        //         <UploadTrailer
                        //           id={sessionStorage.getItem("content_id")}
                        //           upload={{
                        //             ...upload,
                        //             _id: sessionStorage.getItem("content_id"),
                        //             type: "movie_trailer",
                        //           }}
                        //           activeObj={movie}
                        //         />
                        //       </Col>
                        //     </Row>
                        //   </Col>
                        // </Row>
                        <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          className="upload-video-wrapper"
                          style={{ width: "50%" }}
                        >
                          <DirectUpload
                            content_id={sessionStorage.getItem("content_id")}
                            content_type={"movies"}
                            content_title={movie.title}
                            playbackUrl={
                              movie.playbackUrlStatus ? movie.playbackUrlStatus : null
                            }
                            duration={movie?.duration}
                            status={
                              movie.playbackUrlStatus !== undefined
                                ? movie.playbackUrlStatus === "ready"
                                  ? "ready"
                                  : "uploaded"
                                : ""
                            }
                            card_title={"Main Content"}
                            custom_image={
                              movie.thumbnail_content ? movie.thumbnail_content : movie?.detailImage
                            }
                            download_url={
                              movie.mp4PlaybackUrl ? movie.mp4PlaybackUrl : null
                            }
                          />
                        </div>
                        <div
                          className="upload-video-wrapper"
                          style={{ width: "50%" }}
                        >
                          <DirectUpload
                            content_id={sessionStorage.getItem("content_id")}
                            content_type={"movies_trailer"}
                            content_title={movie.title}
                            playbackUrl={
                              movie.mp4Trailer ? movie.mp4Trailer : null
                            }
                            duration={movie?.duration}
                            status={
                              movie.trailerStatus !== undefined
                                ? movie.trailerStatus === "ready"
                                  ? "ready"
                                  : "uploaded"
                                : ""
                            }
                            card_title={"Trailer"}
                            custom_image={
                              movie.thumbnail_trailer ? movie.thumbnail_trailer : movie?.detailImage
                            }
                            download_url={
                              movie.mp4Trailer ? movie.mp4Trailer : null
                            }
                          />
                        </div>
                      </div>

                      )}

                      {streamType === "default" && (
                        <Row
                          gutter={30}
                          style={{
                            width: "100%",
                            marginTop: "20px",
                            marginLeft: "1px",
                          }}
                        >
                          <Card
                            title="Embed Code"
                            style={{
                              width: "75%",
                              marginLeft: "3px",
                            }}
                            size="small"
                            extra={
                              <Tooltip title="Copy Code">
                                <Button
                                  type="text"
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      `<div style="position: relative; aspect-ratio: 16/9;">\n  <iframe \n    src=https://tv.rocketlane.com/player/standalone/${movie._id} \n    loading="lazy" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;" \n    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"\n    allowfullscreen="true">\n  </iframe>\n</div>`
                                    );
                                    message.success("Copied Embed code");
                                  }}
                                >
                                  <CopyOutlined />
                                </Button>
                              </Tooltip>
                            }
                          >
                            <Space direction="vertical">
                              <HtmlDisplay
                                htmlContent={`<div style="position: relative; aspect-ratio: 16/9;">\n  <iframe \n    src=https://tv.rocketlane.com/player/standalone/${movie._id} \n    loading="lazy" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;" \n    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"\n    allowfullscreen="true">\n  </iframe>\n</div>`}
                                style={{ width: "70%", overflow: "auto" }}
                              />
                            </Space>
                          </Card>
                        </Row>
                      )}

                      {streamType === "default" && (
                        <Row gutter={30} style={{ marginTop: "20px" }}>
                          <Col span={24}>
                            <Space>
                              Enable Auto Generated Transcripts{"  "}
                              <Switch
                                checked={checked}
                                onChange={setChecked}
                                style={{ marginLeft: "10px" }}
                              />
                              <Tooltip title="Enabling this will show auto-generated transcripts on the player, By default transcripts automatically generated are disabled">
                                <QuestionCircleOutlined
                                  style={{
                                    fontSize: "20px",
                                    marginLeft: "5px",
                                    marginTop: "5px",
                                  }}
                                />
                              </Tooltip>
                            </Space>
                          </Col>
                        </Row>
                      )}
                      {streamType === "default" && (
                        <Row gutter={30} style={{ marginTop: "30px" }}>
                          <Col span={24}>
                            <Title level={4}>
                              Transcripts{" "}
                              <span style={{ fontSize: "15px" }}></span>
                            </Title>
                          </Col>
                          <Col span={24}>
                            <UploadSubtitles
                              style={{ marginTop: "10px" }}
                              id={`${movie}`}
                              upload={{
                                _id: sessionStorage.getItem("content_id"),
                                type: "movie",
                              }}
                              subtitles={
                                movie && "subtitles" in movie
                                  ? movie.subtitles
                                  : {}
                              }
                              updateContent={[movie, setMovie]}
                              updateFlag={[
                                subtitlesUploaded,
                                setSubtitlesUploaded,
                              ]}
                            />
                            {movie.subtitles || subtitlesUploaded ? null : (
                              <Col
                                span={10}
                                style={{ marginTop: "10px" }}
                              ></Col>
                            )}
                          </Col>
                          <Divider />
                        </Row>
                      )}

                      {streamType === "default" && (
                        <Row gutter={30} style={{ marginTop: "30px" }}>
                          {/* <Col span={24}>
                            <Title level={4}>
                              Stream <span style={{ fontSize: "15px" }}></span>
                            </Title>
                          </Col> */}
                          {/* <Col span={24}>
                            <Form.Item
                              name="skipIntroStart"
                              label="Skip Intro Start"
                              extra={"Maximum value is 10800"}
                              help="Accepts only integers from the input"
                              rules={[
                                {
                                  validator: validateOptionalNumberField,
                                },
                              ]}
                            >
                              <InputNumber
                                placeholder="Enter start time in seconds"
                                disabled={contentType === "song"}
                                min={1}
                                max={10800}
                              />
                            </Form.Item>
                            <Form.Item
                              name="skipIntroEnd"
                              label="Skip Intro End"
                              extra={"Maximum value is 10800"}
                              help="Accepts only integers from the input"
                              rules={[
                                { validator: validateOptionalNumberField },
                              ]}
                            >
                              <InputNumber
                                placeholder="Enter end time in seconds"
                                disabled={contentType === "song"}
                                min={1}
                                max={10800}
                              />
                            </Form.Item>
                          </Col> */}
                          {/* <Divider /> */}
                          <Space
                            direction="vertical"
                            style={{ marginLeft: "1%" }}
                          >
                            <Row gutter={30}>
                              <Col span={24}>
                                <Title level={4}>Also available on</Title>
                              </Col>
                            </Row>
                            <Row>
                              <Space direction="vertical">
                                <Space direction="horizontal" align="baseline">
                                  <img
                                    src="/images/apple-podcast.svg"
                                    height={25}
                                    width={25}
                                  />
                                  <Form.Item
                                    name={"apple_podcast"}
                                    rules={[
                                      {
                                        required: false,
                                        validator: validateApplePodcastInput,
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder="Enter apple podcast url"
                                      style={{ width: "200%" }}
                                    />
                                  </Form.Item>
                                </Space>
                                <Space direction="horizontal" align="baseline">
                                  <img
                                    src="/images/spotify-icon.svg"
                                    height={25}
                                    width={25}
                                  />
                                  <Form.Item
                                    name={"spotify"}
                                    rules={[
                                      {
                                        required: false,
                                        validator: validateSpotifyInput,
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder="Input spotify url"
                                      style={{ width: "200%" }}
                                    />
                                  </Form.Item>
                                </Space>
                                <Space direction="horizontal" align="baseline">
                                  <img
                                    src="/images/youtube-icon.svg"
                                    height={25}
                                    width={25}
                                  />
                                  <Form.Item
                                    name={"youtube"}
                                    rules={[
                                      {
                                        required: false,
                                        validator: validateYoutubeInput,
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder="Input youtube url"
                                      style={{ width: "200%" }}
                                    />
                                  </Form.Item>
                                </Space>
                              </Space>
                            </Row>
                          </Space>
                          <Divider style={{ margin: "7px 0" }} />
                        </Row>
                      )}
                      <Row justify="end">
                        <Col span={24} style={{ textAlign: "right" }}>
                          <Button
                            type="primary"
                            style={{ padding: "0 20px" }}
                            onClick={handleVideoAssestsSubmit}
                          >
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  <TabPane tab="Availability" key="4">
                    {/* Locations Table  */}
                    {/* <Row>
                      <Col span={24}>
                        <Form layout="vertical" form={geoAccessForm}>
                          <Form.Item
                            name="listType"
                            label={"Content access"}
                            rules={[{ required: true }]}
                            style={{ marginTop: "2%" }}
                            noStyle
                            initialValue={"allow_all"}
                          >
                            <Radio.Group
                              value={listType}
                              onChange={(e) => setListType(e.target.value)}
                              defaultValue={"allow_all"}
                              style={{ marginTop: "1%" }}
                              disabled={true}
                            >
                              <Radio value="allow_all">Allow Globally</Radio>
                              <Radio value="allow">Allow List</Radio>
                              <Radio value="disallow">Deny List</Radio>
                            </Radio.Group>
                          </Form.Item>

                          {["allow", "disallow"].includes(listType) && (
                            <Form.Item
                              name={`countryMap`}
                              label={"Countries"}
                              rules={[{ required: true }]}
                              style={{ width: "100%", marginTop: "1%" }}
                            >
                              <Select
                                showSearch
                                mode="multiple"
                                placeholder={`Select countries to be ${listType}ed..`}
                                style={{ width: "100%" }}
                              >
                                {Object.entries(countryCodes).map(
                                  ([code, name]) => (
                                    <Option key={name} value={code}>
                                      {name}
                                    </Option>
                                  )
                                )}
                              </Select>
                            </Form.Item>
                          )}
                        </Form>
                      </Col>
                    </Row>
                    <Divider /> */}
                    {/* Pricing Model Block */}
                    {/* 
                    <Row>
                      <Col span={24}>
                        <Text>
                          <strong>
                            Which business model do you want to use?{" "}
                          </strong>
                          <span style={{ fontSize: "15px" }}></span>
                        </Text>
                      </Col>
                      <Form layout="vertical" form={monetizationStreamingForm}>
                        <Row
                          style={{ marginTop: "10px", marginBottom: "10px" }}
                        >
                          <Radio.Group
                            onChange={(e) => {
                              setModelType(e.target.value);
                              console.log(e.target.value);
                            }}
                            defaultValue="free"
                            disabled={true}
                          >
                            <Radio value={"subscription"}>Subscription</Radio>
                            <Radio value={"free"}>Free</Radio>
                            <Radio value={"rent"}>Buy & Rent</Radio>
                          </Radio.Group>
                        </Row>
                        {modelType === "rent" && (
                          <Row>
                            <Form.List name="currencyMap">
                              {(fields, { add, remove }) => (
                                <>
                                  <Space
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                    }}
                                    align="baseline"
                                  >
                                    <Form.Item
                                      name={"def_currency_1"}
                                      label="Currency"
                                      style={{ width: "100%" }}
                                      className="form-item-selector"
                                    >
                                      <Select
                                        style={{ width: "200px" }}
                                        defaultValue={"INR"}
                                      >
                                        {codes.map((cc) => (
                                          <Select.Option
                                            key={cc}
                                            value={cc}
                                            placeholder={"Select a Currency"}
                                          >
                                            {currencycodes[cc]}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                    <Form.Item name={"def_mrp_1"} label="MRP">
                                      <InputNumber placeholder="Enter amount" />
                                    </Form.Item>
                                  </Space>
                                  <Space
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      marginTop: -15,
                                    }}
                                    align="baseline"
                                  >
                                    <Form.Item
                                      name={"def_currency_2"}
                                      label="Currency"
                                      style={{ width: "100%" }}
                                      className="form-item-selector"
                                      noStyle
                                    >
                                      <Select
                                        style={{ width: "200px" }}
                                        defaultValue={"USD"}
                                      >
                                        {codes.map((cc) => (
                                          <Select.Option
                                            key={cc}
                                            value={cc}
                                            placeholder={"Select a Currency"}
                                          >
                                            {currencycodes[cc]}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                    <Form.Item
                                      name={"def_mrp_2"}
                                      label="MRP"
                                      noStyle
                                    >
                                      <InputNumber placeholder="Enter amount" />
                                    </Form.Item>
                                  </Space>
                                  {fields.map(({ key, name, ...restField }) => (
                                    <Space
                                      key={key}
                                      style={{
                                        display: "flex",
                                        marginTop: 8,
                                        marginBottom: 8,
                                        width: "100%",
                                      }}
                                      align="baseline"
                                    >
                                      <Form.Item
                                        {...restField}
                                        name={[name, "currency"]}
                                        label="Currency"
                                        style={{
                                          width: "100%",
                                          columnWidth: "40%",
                                        }}
                                        className="form-item-selector"
                                        noStyle
                                      >
                                        <Select
                                          style={{ width: "200px" }}
                                          placeholder={"Select a Currency"}
                                        >
                                          {codes.map((cc) => (
                                            <Select.Option
                                              key={cc}
                                              value={cc}
                                              placeholder={"Select a Currency"}
                                            >
                                              {currencycodes[cc]}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                      <Form.Item
                                        {...restField}
                                        name={[name, "mrp"]}
                                        label="MRP"
                                        noStyle
                                      >
                                        <InputNumber placeholder="Enter amount" />
                                      </Form.Item>
                                      {fields.length > 0 &&
                                        key === fields.length - 1 &&
                                        fields.length <= 6 && (
                                          <>
                                            <PlusCircleOutlined
                                              onClick={() => add()}
                                            />
                                            <MinusCircleOutlined
                                              onClick={() => remove(name)}
                                            />
                                          </>
                                        )}
                                    </Space>
                                  ))}
                                  {fields.length === 0 && (
                                    <Form.Item style={{ marginTop: 8 }}>
                                      <Button
                                        type="dashed"
                                        onClick={() => add()}
                                        block
                                        icon={<PlusOutlined />}
                                      >
                                        Add currency
                                      </Button>
                                    </Form.Item>
                                  )}
                                </>
                              )}
                            </Form.List>
                          </Row>
                        )}
                      </Form>
                    </Row>
                    <Divider />
                    */}

                    <Row gutter={30}>
                      <Col span={24}>
                        <Text>
                          <strong>
                            Availability?{" "}
                            <Tooltip title="Only super admin can update the availability status">
                              <InfoCircleOutlined />
                            </Tooltip>
                          </strong>
                          <span style={{ fontSize: "15px" }}></span>
                        </Text>
                      </Col>
                      <div style={{ marginLeft: "1%" }}>
                        <Form form={availabilityForm} layout="vertical">
                          <Form.Item
                            name={"availability"}
                            label=""
                            rules={[{ required: true }]}
                            initialValue={"unpublished"}
                          >
                            <Radio.Group
                              defaultValue={availability}
                              onChange={(v) => setAvailability(v.target.value)}
                              disabled={superAdmin !== true}
                            >
                              <Radio value={"perpetual"}>Published</Radio>
                              <Radio value={"unpublished"}>Unpublished</Radio>
                              <Radio value={"restricted"}>
                                Schedule a date
                              </Radio>
                            </Radio.Group>
                          </Form.Item>
                          {availability === "restricted" && (
                            <div style={{ marginLeft: "2%" }}>
                              <Form.Item
                                name={"startDate"}
                                label="Publish Date & Time (IST)"
                                rules={[{ required: true }]}
                              >
                                <DatePicker
                                  showTime
                                  onChange={(_, dateString) => {
                                    setStartDate(dayjs(dateString));
                                  }}
                                />
                              </Form.Item>
                            </div>
                          )}
                        </Form>
                      </div>
                    </Row>

                    {/* gating content and un gating content for standlone content */}
                    <Row>
                      <Col span={24}>
                        <Text>
                          <strong>Gating Content</strong>
                          <span style={{ fontSize: "15px" }}></span>
                        </Text>
                        <div style={{ marginLeft: "1%" }}>
                          <Form form={availabilityForm} layout="vertical">
                            <Form.Item
                              name={"gating"}
                              label=""
                              rules={[{ required: true }]}
                              initialValue={"ungating"}
                            >
                              <Radio.Group
                                defaultValue={gatingType}
                                onChange={(e) => setGatingType(e.target.value)}
                              >
                                <Radio value={true}>Gating</Radio>
                                <Radio value={false}>Ungating</Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Form>
                        </div>
                      </Col>
                    </Row>
                    <Divider />
                    <Row justify="end">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          style={{ padding: "0 20px" }}
                          onClick={handleAvailabilitySubmit}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
          )}
          {/* Adding details content for Episodes series */}
          {addSeriesContent && (
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={24}>
                    <Row>
                      <Breadcrumb
                        items={[
                          {
                            title: (
                              <a onClick={handleReset}> Manage Content </a>
                            ),
                          },
                          {
                            title:
                              seriesRecord.title.length > 50 ? (
                                <a href="#">
                                  <span>{`${seriesRecord.title.slice(
                                    0,
                                    50
                                  )}...`}</span>
                                </a>
                              ) : (
                                seriesRecord.title
                              ),
                          },
                          {
                            title: seriesId.title ? (
                              seriesId.title.length > 50 ? (
                                <a href="#">
                                  <span>{`${seriesId.title.slice(
                                    0,
                                    50
                                  )}...`}</span>
                                </a>
                              ) : (
                                seriesId.title
                              )
                            ) : (
                              `Season ${seriesId.season}`
                            ),
                          },
                        ]}
                      />
                      <Col span={24}>
                        <Title level={3} style={{ marginBottom: "10px" }}>
                          {seriesId.title ? (
                            seriesId.title.length > 50 ? (
                              <span>{`${seriesId.title.slice(0, 50)}...`}</span>
                            ) : (
                              seriesId.title
                            )
                          ) : (
                            `Season ${seriesId.season}`
                          )}
                        </Title>
                        <Text type="secondary">
                          <>
                            <Tag
                              color="blue"
                              style={{
                                borderRadius: "100px",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              English
                            </Tag>
                            {Telugu && (
                              <Tag
                                color="blue"
                                style={{
                                  borderRadius: "100px",
                                  paddingLeft: "10px",
                                  paddingRight: "10px",
                                }}
                              >
                                Spanish
                              </Tag>
                            )}
                            {Hindi && (
                              <Tag
                                color="blue"
                                style={{
                                  borderRadius: "100px",
                                  paddingLeft: "10px",
                                  paddingRight: "10px",
                                }}
                              >
                                German
                              </Tag>
                            )}
                            {Tamil && (
                              <Tag
                                color="blue"
                                style={{
                                  borderRadius: "100px",
                                  paddingLeft: "10px",
                                  paddingRight: "10px",
                                }}
                              >
                                French
                              </Tag>
                            )}
                          </>
                          <Popover
                            content={addLanguagePopover}
                            trigger="click"
                            placement="bottom"
                            title="Add a Language"
                          >
                            <Button
                              size="small"
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              Add
                            </Button>
                          </Popover>
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row justify={"end"}>
                  <Button
                    type="primary"
                    danger
                    onClick={() => {
                      confirm({
                        title: "Are you sure you want to delete this season?",
                        icon: <ExclamationCircleOutlined />,
                        content:
                          "All the episodes of this season will also be erased.",
                        okText: "Yes",
                        okType: "primary",
                        okButtonProps: { danger: true },
                        cancelText: "No",
                        onOk() {
                          handleDeleteSeason(seasonId);
                        },
                      });
                      console.log("clicked on delete season");
                      console.log(seriesRecord);
                      console.log(seasonId);
                    }}
                  >
                    Delete Season
                  </Button>
                </Row>
              </Col>
              <Col span={24} style={{ marginTop: "15px" }}>
                <Tabs
                  //  activeKey="catalogListing"
                  className="add-content-tabs addContentTabs"
                  onChange={(v) => {
                    setActiveKey(v);
                    setCurrentEpisode(null);
                  }}
                  activeKey={activeKey}
                >
                  <TabPane tab={<label>Catalog Listing</label>} key="1">
                    <Form layout="vertical" form={seriesContentInfoForm}>
                      <Row gutter={30}>
                        <Col span={12}>
                          <Form.Item
                            name={"title"}
                            label="Title"
                            rules={[
                              {
                                required: true,
                                validator: validateInputFields,
                              },
                            ]}
                            extra="English"
                          >
                            <Input
                              placeholder="Enter title here..."
                              value={seriesId.title}
                              maxLength={255}
                              showCount
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            // name={'category'}
                            label="Category"
                            rules={[{ required: true }]}
                          >
                            <Select
                              defaultValue="movie"
                              onChange={setContentType}
                              placeholder="Select a category"
                              disabled={true}
                              value={seriesRecord.category}
                            >
                              <Option value="movie">Movie</Option>
                              <Option value="song">Song</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      {Telugu && (
                        <Row gutter={30}>
                          <Col span={12}>
                            <Form.Item
                              name={"teluguTitle"}
                              label="Title"
                              rules={[
                                {
                                  required: true,
                                  validator: validateInputFields,
                                },
                              ]}
                              extra="Spanish"
                            >
                              <Input
                                placeholder="Enter title here..."
                                value={seriesId.TeluguTitle}
                                maxLength={255}
                                showCount
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      {Hindi && (
                        <Row gutter={30}>
                          <Col span={12}>
                            <Form.Item
                              name={"hindiTitle"}
                              label="Title"
                              rules={[
                                {
                                  required: true,
                                  validator: validateInputFields,
                                },
                              ]}
                              extra="German"
                            >
                              <Input
                                placeholder="Enter title here..."
                                value={seriesId.HindiTitle}
                                maxLength={255}
                                showCount
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      {Tamil && (
                        <Row gutter={30}>
                          <Col span={12}>
                            <Form.Item
                              name={"tamilTitle"}
                              label="Title"
                              rules={[
                                {
                                  required: true,
                                  validator: validateInputFields,
                                },
                              ]}
                              extra="French"
                            >
                              <Input
                                placeholder="Enter title here..."
                                value={seriesId.TamilTitle}
                                maxLength={255}
                                showCount
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col span={24}>
                          <Form.Item
                            name="description"
                            label="Synopsis (English)"
                            dataIndex={"description"}
                            initialValue={seriesId.description}
                            rules={[
                              {
                                required: true,
                                validator: validateDescriptionFields,
                              },
                            ]}
                          >
                            <TextArea
                              placeholder="Enter Synopsis here..."
                              extra="English"
                              showCount
                              maxLength={1000}
                              rows="4"
                              value={seriesId.description}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      {Telugu && (
                        <Row gutter={30}>
                          <Col span={24}>
                            <Form.Item
                              name={"teluguDescription"}
                              dataIndex={"teluguDescription"}
                              label="Synopsis (Spanish)"
                              rules={[
                                {
                                  required: true,
                                  validator: validateDescriptionFields,
                                },
                              ]}
                            >
                              <TextArea
                                rows={4}
                                placeholder="Enter short description of the movie"
                                showCount
                                maxLength={1000}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      {Hindi && (
                        <Row gutter={30}>
                          <Col span={24}>
                            <Form.Item
                              name={"hindiDescription"}
                              dataIndex={"hindiDescription"}
                              label="Synopsis (German)"
                              rules={[
                                {
                                  required: true,
                                  validator: validateDescriptionFields,
                                },
                              ]}
                            >
                              <TextArea
                                rows={4}
                                placeholder="Enter short description of the movie"
                                showCount
                                maxLength={1000}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      {Tamil && (
                        <Row gutter={30}>
                          <Col span={24}>
                            <Form.Item
                              name={"tamilDescription"}
                              dataIndex={"tamilDescription"}
                              label="Synopsis (French)"
                              rules={[
                                {
                                  required: true,
                                  validator: validateDescriptionFields,
                                },
                              ]}
                            >
                              <TextArea
                                rows={4}
                                placeholder="Enter short description of the movie"
                                showCount
                                maxLength={1000}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      <Row gutter={30}>
                        <Col span={12}>
                          <Form.Item
                            name={"genre"}
                            label="Themes"
                            rules={[{ required: true }]}
                            dataIndex={"genre"}
                          >
                            <Select
                              mode="multiple"
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {genres &&
                                genres.map((genre) => (
                                  <Option key={genre.name} value={genre._id}>
                                    {genre.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="releaseDate"
                            label="Publish Date"
                            rules={[{ required: true }]}
                          >
                            <DatePicker
                              style={{ width: "100%" }}
                              onChange={(_, datestring) =>
                                setReleaseDate(dayjs(datestring))
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      {/* <Row gutter={30}>
                        <Col span={24}>
                          <Form.Item
                            name={"originCountry"}
                            dataIndex={"originCountry"}
                            label="Country/Region of origin"
                            rules={[{ required: true }]}
                            extra="The order of countries/regions is important, with the first entry corresponding to the production company with the greatest contribution to the title."
                          >
                            <Select placeholder={"Select a country"} showSearch>
                              {Object.entries(countryCodes).map(
                                ([code, name]) => (
                                  <Option key={name} value={code}>
                                    {name}
                                  </Option>
                                )
                              )}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row> */}
                      <Row gutter={30}>
                        {/* <Col span={12}>
                          <Form.Item
                            name={"language"}
                            label="Original language (Optional)"
                          >
                            <Select
                              placeholder="Select a language"
                              mode="multiple"
                              showSearch
                            >
                              {languages &&
                                languages.map((language) => (
                                  <Option value={language.name}>
                                    {language.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col> */}
                        {/* <Col span={12}>
                          <Form.Item
                            name="releaseDate"
                            label="Publish Date"
                            rules={[{ required: true }]}
                          >
                            <DatePicker
                              style={{ width: "100%" }}
                              onChange={(_, datestring) =>
                                setReleaseDate(dayjs(datestring))
                              }
                            />
                          </Form.Item>
                        </Col> */}
                      </Row>
                      <Divider style={{ marginTop: 0 }} />
                      <Row>
                        <Col>
                          <Title level={5}>Graphic assets </Title>
                          <Text>
                            Key art (also  known as cover or the title art)
                            represents your title on FastPix Video App.{" "}
                            <strong>
                              Please include legible titles on your key art.
                            </strong>{" "}
                            The background image adds visual interests to video
                            detail pages.
                          </Text>
                        </Col>
                      </Row>
                      <div style={{ marginLeft: "10%", marginRight: "10%" }}>
                        <Row
                          gutter={30}
                          style={{ marginTop: "20px" }}
                          justify={"center"}
                        >
                          {/* 16:9 Image */}
                          <Col span="8">
                            <Row>
                              <Col span={24}>
                                <Text>
                                  <strong>
                                    <font color="red">*</font>Key art
                                  </strong>{" "}
                                  (16:9){" "}
                                  {/* <Tooltip title="Some description text runs here like this">
                                                                      <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                                  </Tooltip> */}
                                </Text>
                              </Col>
                              <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                                <Form.Item
                                  name={"detailImage"}
                                  rules={[{ required: true }]}
                                >
                                  <Upload
                                    showUploadList={false}
                                    action={`${apiUrl}/uploads/fastpixUploads`}
                                    headers={{
                                      authorization: `Bearer ${token}`,
                                    }}
                                    beforeUpload={beforeImageUpload}
                                    onChange={
                                      handleDetailImageUploadStatusChange
                                    }
                                  >
                                    <Button size="small">Browse...</Button>
                                  </Upload>
                                </Form.Item>{" "}
                                {/* <Button size="small">Google Drive</Button> */}
                              </Col>
                              <Col span={24}>
                                {detailImageUrl ? (
                                  <Image
                                    style={{
                                      aspectRatio: "16/9",
                                      objectFit: "contain",
                                    }}
                                    src={detailImageUrl}
                                  />
                                ) : (
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                )}
                              </Col>
                            </Row>
                          </Col>
                          <Col span={8}> </Col>
                          {/* 3:4 Image */}
                          <Col span="8">
                            <Row>
                              <Col span={24}>
                                <Text>
                                  <strong>
                                    <font color="red">*</font>Key art
                                  </strong>{" "}
                                  (3:4){" "}
                                  {/* <Tooltip title="Some description text runs here like this">
                                                                      <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                                  </Tooltip> */}
                                </Text>
                              </Col>
                              <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                                <Form.Item
                                  name={"cardImage"}
                                  rules={[{ required: true }]}
                                >
                                  <Upload
                                    showUploadList={false}
                                    action={`${apiUrl}/uploads/fastpixUploads`}
                                    headers={{
                                      authorization: `Bearer ${token}`,
                                    }}
                                    beforeUpload={beforeImageUpload}
                                    onChange={handleCardImageUploadStatusChange}
                                  >
                                    <Button size="small">Browse...</Button>
                                  </Upload>
                                </Form.Item>
                                {/* <Button size="small">Google Drive</Button> */}
                              </Col>
                              <Col span={24}>
                                {cardImageUrl ? (
                                  <Image
                                    style={{
                                      aspectRatio: "16/9",
                                      objectFit: "contain",
                                    }}
                                    src={cardImageUrl}
                                  />
                                ) : (
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Divider style={{ margin: "10px 2" }} />
                        </Row>
                        <Row
                          gutter={30}
                          style={{ marginTop: "20px" }}
                          justify={"center"}
                        >
                          {/* Logo Image */}
                          <Col span="8">
                            <Row>
                              <Col span={24}>
                                <Text>
                                  <strong>Logo Image (16:9)</strong> (Optional){" "}
                                </Text>
                              </Col>
                              <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                                <Form.Item
                                  name={"logoImage"}
                                  rules={[{ required: false }]}
                                >
                                  <Upload
                                    showUploadList={false}
                                    action={`${apiUrl}/uploads/fastpixUploads`}
                                    headers={{
                                      authorization: `Bearer ${token}`,
                                    }}
                                    beforeUpload={beforeImageUpload}
                                    onChange={handleLogoImageUploadStatusChange}
                                  >
                                    <Button size="small">Browse...</Button>
                                  </Upload>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                {logoImageUrl ? (
                                  <Image
                                    style={{
                                      aspectRatio: "16/9",
                                      objectFit: "contain",
                                    }}
                                    src={logoImageUrl}
                                  />
                                ) : (
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                )}
                              </Col>
                            </Row>
                          </Col>
                          <Col span={8}> </Col>
                          {/* Background Image */}
                          <Col span="8">
                            <Row>
                              <Col span={24}>
                                <Text>
                                  <strong>
                                    <font color="red">*</font>Background Image
                                    (21:9)
                                  </strong>{" "}
                                  {/* <Tooltip title="Some description text runs here like this">
                                                                      <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                                  </Tooltip> */}
                                </Text>
                              </Col>
                              <Col span={24} style={{ margin: "10px 0 5px 0" }}>
                                <Form.Item
                                  name={"trailerImage"}
                                  rules={[{ required: true }]}
                                >
                                  <Upload
                                    showUploadList={false}
                                    action={`${apiUrl}/uploads/fastpixUploads`}
                                    headers={{
                                      authorization: `Bearer ${token}`,
                                    }}
                                    beforeUpload={beforeImageUpload}
                                    onChange={
                                      handleTrailerImageUploadStatusChange
                                    }
                                  >
                                    <Button size="small">Browse...</Button>
                                  </Upload>
                                </Form.Item>
                                {/* <Button size="small">Google Drive</Button> */}
                              </Col>
                              <Col span={24}>
                                {trailerImageUrl ? (
                                  <Image
                                    style={{
                                      aspectRatio: "16/9",
                                      objectFit: "contain",
                                    }}
                                    src={trailerImageUrl}
                                  />
                                ) : (
                                  <Text
                                    type="warning"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <span>
                                      <WarningFilled />
                                    </span>{" "}
                                    Click to Upload Image
                                  </Text>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                      <Divider style={{ margin: "5px 0" }} />
                      <Row justify="right" style={{ marginTop: "50px" }}>
                        <Col span={24} style={{ textAlign: "right" }}>
                          <Button
                            type="primary"
                            style={{ padding: "0 20px" }}
                            onClick={handleSeriesContentInfoSubmit}
                          >
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  <TabPane tab="Cast & Crew" key="2">
                    <Form
                      layout="vertical"
                      form={seriesCastCrewAvailabilityForm}
                    >
                      <Row gutter={30}>
                        <Col span={24}>
                          <Title level={4}>
                            Host <font color="red">*</font>
                          </Title>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="hosts"
                            label=""
                            rules={[{ required: true }]}
                          >
                            <Select
                              placeholder="Select hosts here..."
                              showSearch
                              mode="multiple"
                              value={seriesId.hosts ? seriesId.hosts : null}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {hosts &&
                                hosts.map((studio) => (
                                  <Option key={studio.name} value={studio._id}>
                                    {studio.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}></Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <Title level={4}>Guests</Title>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="guests"
                            label=""
                            rules={[{ required: false }]}
                          >
                            <Select
                              placeholder="Select guests here..."
                              showSearch
                              mode="multiple"
                              value={seriesId.guests ? seriesId.guests : null}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {guests &&
                                guests.map((studio) => (
                                  <Option key={studio.name} value={studio._id}>
                                    {studio.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Title level={4}> Technical Help</Title>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="tech"
                            label=""
                            rules={[{ required: false }]}
                          >
                            <Select
                              placeholder="Select tech help members here..."
                              showSearch
                              mode="multiple"
                              value={seriesId.tech ? seriesId.tech : null}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {tech &&
                                tech.map((studio) => (
                                  <Option key={studio.name} value={studio._id}>
                                    {studio.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        {/* <Col span={24} style={{ marginTop: '15px' }}>
                                                      <Row>
                                                          <Col span={24}>
                                                              <Title level={4} style={{ marginBottom: '0' }}>
                                                                  Influencers <font color="red">*</font>
                                                              </Title>
                                                              <Text type="secondary">
                                                                  The top two to four influencers provided below will
                                                                  be indicated as Starring across Meander Video apps.
                                                              </Text>
                                                          </Col>
                                                          <Col span={24} style={{ marginTop: '15px' }}>
                                                              <Row gutter={30} align="middle">
                                                                  <Col span={7}>
                                                                      <Row>
                                                                          <Col span={24}>
                                                                              <Form.Item name="influencers" label="" rules={[{ required: true }]}>
                                                                                  <Select placeholder="Select Influencers here..."
                                                                                      showSearch
                                                                                      mode="multiple"
                                                                                      // className="form-card-selector"
                                                                                      style={{ width: '360%' }}
                                                                                      value={seriesId.actors}
                                                                                      placement={'bottomLeft'}
                                                                                  >
                                                                                      {actors.map((actor) => (
                                                                                          <Option key={actor.key} value={actor.name}>
                                                                                              {actor.name}
                                                                                          </Option>
                                                                                      ))}
                                                                                  </Select>
                                                                              </Form.Item>
                                                                          </Col>
                                                                      </Row>
                                                                  </Col>
                                                              </Row>
                                                          </Col>
                                                      </Row>
                                                      <Row gutter={30}>
                                                      </Row>
                                                  </Col> */}
                        <Col span={24}>
                          <Divider />
                        </Col>
                      </Row>
                      <Row justify="end">
                        <Col span={24} style={{ textAlign: "right" }}>
                          <Button
                            type="primary"
                            style={{ padding: "0 20px" }}
                            onClick={handleSeriesCastCrewSubmit}
                          >
                            Save
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  <TabPane tab="Video Assets" key={"3"}>
                    <div style={{width: "50%"}}>
                        <DirectUpload
                            content_id={seriesId?._id}
                            content_type={"season_trailer"}
                            content_title={seriesId.title}
                            playbackUrl={
                              seriesId.trailer ? seriesId.trailer : null
                            }
                            duration={seriesId?.duration}
                            status={
                              seriesId?.trailerStatus !== undefined
                                ? seriesId?.trailerStatus === "ready"
                                  ? "ready"
                                  : "uploaded"
                                : ""
                            }
                            card_title={"Trailer"}
                            custom_image={
                              seriesId.thumbnail_trailer ? seriesId.thumbnail_trailer :  seriesId?.detailImage
                            }
                            download_url={
                              seriesId.mp4Trailer ? seriesId.mp4Trailer : null
                            }
                        />
                    </div>
                    {/* <Row>
                      <Col span={24}>
                        <Row gutter={30} style={{ marginTop: "20px" }}>
                          <Col span={6}>Trailer (optional)</Col>
                          <Col span={6}>
                            {"trailer" in seriesId ? (
                              <Tag color="green" style={{ fontSize: 16 }}>
                                Trailer Exists
                              </Tag>
                            ) : null}
                          </Col>
                          <Col span={6}>
                            <UploadTrailer
                              id={seasonId}
                              upload={{
                                ...upload,
                                _id: seasonId,
                                type: "season_trailer",
                              }}
                              activeObj={seriesId}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row> */}
                    
                    <Divider />
                    <Row justify="end">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          style={{ padding: "0 20px" }}
                          onClick={() => setActiveKey("4")}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                    {/* <Form layout="vertical" form={videoAssetsForm}>
                                              <Row gutter={30}>
                                                  <Col span={24}>
                                                  </Col>
                                              </Row>
                                              {streamType === "default" && (<Row>
                                                  <Col span={24}>
                                                      <Row gutter={30} style={{ marginTop: '20px' }}>
                                                          <Col span={6}>Trailer (optional)</Col>
                                                          <Col span={6}>
                                                              {"trailer" in seriesId ? (
                                                                  <Tag color="green" style={{ fontSize: 16 }}>
                                                                      Trailer Exists
                                                                  </Tag>
                                                              ) : null}
                                                          </Col>
                                                          <Col span={6}>
                                                              <UploadTrailer
                                                                  id={sessionStorage.getItem('content_id')}
                                                                  upload={{
                                                                      ...upload,
                                                                      _id: sessionStorage.getItem('content_id'),
                                                                      type: "series_trailer",
                                                                  }}
                                                                  activeObj={seriesId}
                                                              />
                                                          </Col>
                                                      </Row>
                                                  </Col>
                                              </Row>)}
                                              <Row justify="end">
                                                  <Col span={24} style={{ textAlign: 'right' }}>
                                                      <Button type="primary" style={{ padding: '0 20px' }} onClick={setActiveTab(4)}>
                                                          Next
                                                      </Button>
                                                  </Col>
                                              </Row>
                                          </Form> */}
                  </TabPane>
                  <TabPane tab="Episodes" key={"4"}>
                    <Row>
                      <Col span={24}>
                        <Collapse
                          accordion
                          activeKey={currentEpisode}
                          onChange={setCurrentEpisode}
                          bordered={false}
                        >
                          {console.log(
                            "curren season map data - ",
                            currentSeason
                          )}
                          {currentSeason.map(
                            (ep) =>
                              ep && (
                                <Panel
                                  header={
                                    <>
                                      {`Episode ${ep.number} - ${ep.title}`}
                                      {renderEpisodeHeaderWarning(ep)}
                                    </>
                                  }
                                >
                                  <Episode
                                    seriesId={seriesId}
                                    episode_number={ep._id}
                                    currentSeason={currentSeason[ep.number]}
                                    setCurrentSeason={setCurrentSeason}
                                    season={seasonId}
                                    Hindi={Hindi}
                                    Telugu={Telugu}
                                    Tamil={Tamil}
                                    refreshControl={[refresh, setRefresh]}
                                    key={`${ep.number}`}
                                    updatePanel={[
                                      currentEpisode,
                                      setCurrentEpisode,
                                    ]}
                                  />
                                </Panel>
                              )
                          )}
                        </Collapse>
                        <Row justify="end" style={{ marginTop: "15px" }}>
                          <Col span={24}>
                            <Button
                              onClick={() => {
                                setEpisodeModalVisible(true);
                              }}
                              type="primary"
                              style={{ padding: "0 20px" }}
                            >
                              Add episode
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Divider />

                    <Row justify="end">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          style={{ padding: "0 20px" }}
                          onClick={() => {
                            setActiveKey("5");
                          }}
                        >
                          Next
                        </Button>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tab="Availability" key="5">
                    {/* Locations Table  */}
                    {/* <Row>
                      <Col span={24}>
                        <Form layout="vertical" form={geoAccessForm}>
                          <Form.Item
                            name="listType"
                            label={"Content access"}
                            rules={[{ required: true }]}
                            style={{ marginTop: "2%" }}
                            noStyle
                            initialValue={"allow_all"}
                          >
                            <Radio.Group
                              value={listType}
                              onChange={(e) => setListType(e.target.value)}
                              defaultValue={"allow_all"}
                              style={{ marginTop: "1%" }}
                              disabled={true}
                            >
                              <Radio value="allow_all">Allow Globally</Radio>
                              <Radio value="allow">Allow List</Radio>
                              <Radio value="disallow">Deny List</Radio>
                            </Radio.Group>
                          </Form.Item>

                          {["allow", "disallow"].includes(listType) && (
                            <Form.Item
                              name={`countryMap`}
                              label={"Countries"}
                              rules={[{ required: true }]}
                              style={{ width: "100%", marginTop: "1%" }}
                            >
                              <Select
                                showSearch
                                mode="multiple"
                                placeholder={`Select countries to be ${listType}ed..`}
                                style={{ width: "100%" }}
                              >
                                {Object.entries(countryCodes).map(
                                  ([code, name]) => (
                                    <Option key={code} value={code}>
                                      {name}
                                    </Option>
                                  )
                                )}
                              </Select>
                            </Form.Item>
                          )}
                        </Form>
                      </Col>
                    </Row> */}
                    {/* <Divider /> */}
                    {/* Pricing Model Block */}
                    {/* <Row>
                      <Col span={24}>
                        <Text>
                          <strong>
                            Which pricing model do you want to use?{" "}
                          </strong>
                          <span style={{ fontSize: "15px" }}>
                          </span>
                        </Text>
                      </Col>
                      <Form layout="vertical" form={monetizationStreamingForm}>
                        <Col span={24}>
                          <Form.Item name="model" initialValue={"free"}>
                            <Radio.Group
                              defaultValue={"free"}
                              style={{ marginTop: "1%" }}
                              onChange={(e) =>
                                setMonetizationModel(e.target.value)
                              }
                              disabled={true}
                            >
                              <Radio value="rent">Rent</Radio>
                              <Radio value="subscription">Subscription</Radio>
                              <Radio value="free">Free</Radio>
                            </Radio.Group>
                          </Form.Item>
                          {monetizationModel === "rent" && (
                            <>
                              <Form.List name="currencyMap">
                                {(fields, { add, remove }) => (
                                  <>
                                    <Space
                                      style={{
                                        display: "flex",
                                        width: "100%",
                                      }}
                                      align="baseline"
                                    >
                                      <Form.Item
                                        name={"def_currency_1"}
                                        label="Currency"
                                        style={{ width: "100%" }}
                                        className="form-item-selector"
                                      >
                                        <Select
                                          style={{ width: "200px" }}
                                          defaultValue={"INR"}
                                        >
                                          {codes.map((cc) => (
                                            <Select.Option
                                              key={cc}
                                              value={cc}
                                              placeholder={"Select a Currency"}
                                            >
                                              {currencycodes[cc]}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                      <Form.Item name={"def_mrp_1"} label="MRP">
                                        <InputNumber placeholder="Enter amount" />
                                      </Form.Item>
                                    </Space>
                                    <Space
                                      style={{
                                        display: "flex",
                                        width: "100%",
                                        marginTop: -15,
                                      }}
                                      align="baseline"
                                    >
                                      <Form.Item
                                        name={"def_currency_2"}
                                        label="Currency"
                                        style={{ width: "100%" }}
                                        className="form-item-selector"
                                        noStyle
                                      >
                                        <Select
                                          style={{ width: "200px" }}
                                          defaultValue={"USD"}
                                        >
                                          {codes.map((cc) => (
                                            <Select.Option
                                              key={cc}
                                              value={cc}
                                              placeholder={"Select a Currency"}
                                            >
                                              {currencycodes[cc]}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                      <Form.Item
                                        name={"def_mrp_2"}
                                        label="MRP"
                                        noStyle
                                      >
                                        <InputNumber placeholder="Enter amount" />
                                      </Form.Item>
                                    </Space>
                                    {fields.map(
                                      ({ key, name, ...restField }) => (
                                        <Space
                                          key={key}
                                          style={{
                                            display: "flex",
                                            marginTop: 8,
                                            marginBottom: 8,
                                            width: "100%",
                                          }}
                                          align="baseline"
                                        >
                                          <Form.Item
                                            {...restField}
                                            name={[name, "currency"]}
                                            label="Currency"
                                            style={{
                                              width: "100%",
                                              columnWidth: "40%",
                                            }}
                                            className="form-item-selector"
                                            noStyle
                                          >
                                            <Select
                                              style={{ width: "200px" }}
                                              placeholder={"Select a Currency"}
                                            >
                                              {codes.map((cc) => (
                                                <Select.Option
                                                  key={cc}
                                                  value={cc}
                                                  placeholder={
                                                    "Select a Currency"
                                                  }
                                                >
                                                  {currencycodes[cc]}
                                                </Select.Option>
                                              ))}
                                            </Select>
                                          </Form.Item>
                                          <Form.Item
                                            {...restField}
                                            name={[name, "mrp"]}
                                            label="MRP"
                                            noStyle
                                          >
                                            <InputNumber placeholder="Enter amount" />
                                          </Form.Item>
                                          {fields.length > 0 &&
                                            key === fields.length - 1 && (
                                              <>
                                                <PlusCircleOutlined
                                                  onClick={() => add()}
                                                />
                                                <MinusCircleOutlined
                                                  onClick={() => remove(name)}
                                                />
                                              </>
                                            )}
                                        </Space>
                                      )
                                    )}
                                    {fields.length === 0 && (
                                      <Form.Item>
                                        <Button
                                          type="dashed"
                                          onClick={() => add()}
                                          block
                                          icon={<PlusOutlined />}
                                        >
                                          Add currency
                                        </Button>
                                      </Form.Item>
                                    )}
                                  </>
                                )}
                              </Form.List>
                            </>
                          )}
                        </Col>
                      </Form>
                    </Row> */}
                    {/* <Divider /> */}
                    <Row gutter={30}>
                      <Col span={24}>
                        <Text>
                          <strong>
                            Availability?{" "}
                            <Tooltip title="Only super admin can update the availability status">
                              <InfoCircleOutlined />
                            </Tooltip>
                          </strong>
                          <span style={{ fontSize: "15px" }}></span>
                        </Text>
                      </Col>
                      <div style={{ marginLeft: "1%" }}>
                        <Form form={availabilityForm} layout="vertical">
                          <Form.Item
                            name={"availability"}
                            label=""
                            rules={[{ required: true }]}
                            initialValue={"unpublished"}
                          >
                            <Radio.Group
                              defaultValue={availability}
                              onChange={(v) => setAvailability(v.target.value)}
                              disabled={superAdmin !== true}
                            >
                              <Radio value={"perpetual"}>Published</Radio>
                              <Radio value={"unpublished"}>Unpublished</Radio>
                              <Radio value={"restricted"}>
                                Schedule a date
                              </Radio>
                            </Radio.Group>
                          </Form.Item>
                          {availability === "restricted" && (
                            <div style={{ marginLeft: "2%" }}>
                              <Form.Item
                                name={"startDate"}
                                label="Publish Date & Time (IST)"
                                rules={[{ required: true }]}
                              >
                                <DatePicker
                                  showTime
                                  onChange={(_, dateString) => {
                                    setStartDate(dayjs(dateString));
                                  }}
                                />
                              </Form.Item>
                              {/* <Form.Item
                                                                      name={"endDate"}
                                                                      label="Removal Date"
                                                                      rules={[{ required: false }]}
                                                                  >
                                                                      <DatePicker onChange={(_, dateString) => { setEndDate(dayjs(dateString)) }} />
                                                                  </Form.Item> */}
                            </div>
                          )}
                        </Form>
                      </div>
                    </Row>
                    <Divider />
                    <Row justify="end">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          style={{ padding: "0 20px" }}
                          onClick={handleSeriesAvailabilitySubmit}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
          )}
        </div>
      )}

      {/* Standalone Modal */}
      <Modal
        title="Add Title"
        open={showModal}
        onCancel={() => {
          setShowModal(false);
          addStandloneTitleForm.resetFields();
          handleReset();
        }}
        onOk={handleStandAloneTitleSubmit}
        okText={"Continue"}
        maskClosable={false}
      >
        <Form layout="vertical" form={addStandloneTitleForm}>
          <Form.Item
            label="Title"
            name={"title"}
            rules={[
              {
                required: true,
                validator: validateInputFields,
              },
            ]}
            extra={"English"}
          >
            <Input
              placeholder="Enter title here..."
              maxLength={255}
              showCount
            />
          </Form.Item>
          <Form.Item
            label="Category"
            rules={[{ required: true }]}
            name={"category"}
            initialValue={"Interviews"}
          >
            <Select
              defaultValue="Interviews"
              placeholder="Select a Category"
              // onChange={setContentType}
              options={[
                { value: "Educational", label: "Educational" },
                { value: "Interviews", label: "Interviews" },
                { value: "Podcasts", label: "Podcasts" },
              ]}
            />
          </Form.Item>

          {/* <Form.Item
                          label="Title metadata language"
                          rules={[{ required: true }]}
                          name={'metaLanguage'}
                          initialValue={'english'}
                      >
                          <Select
                              defaultValue="english"
                              options={[
                                  { value: 'english', label: 'English' },
                                  { value: 'telugu', label: 'Telugu' },
                                  { value: 'hindi', label: 'Hindi' },
                              ]}
                          />
                      </Form.Item> */}
        </Form>
      </Modal>

      <Modal
        title="Select Content to Edit"
        open={showOptionsModal}
        onCancel={() => {
          setShowOptionsModal(false);
        }}
        onOk={handleSeriesTitleSubmit}
        maskClosable={false}
        footer={null}
      >
        <Card>
          <Row>
            <Title level={5}>Series</Title>
          </Row>
          <Row>
            <Button
              onClick={() => {
                addSeriesTitleForm.setFieldsValue(seriesRecord);
                setSeriesTitleModalType("Edit");
                setSeriesTitleModal(true);
              }}
            >
              Edit Series
            </Button>
            <Button
              onClick={() => {
                console.log("series record - ", seriesRecord);
                handleCreateSeason();
              }}
            >
              Add Season
            </Button>
          </Row>
          <Divider />
          <Row>
            <Title level={5}>Select Season</Title>
            <Select
              style={{ width: "100%" }}
              onChange={(v) => {
                console.log("selected season - ", v);
                setSeasonId(v);
              }}
              allowClear={true}
            >
              {seriesRecord &&
                seriesRecord.season_list.map((item) => (
                  <Option key={item._id} value={item._id}>
                    {item.season}
                  </Option>
                ))}
            </Select>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            {seasonId && (
              <Button
                onClick={() => {
                  console.log("clicked on edit season");
                  handleFetchSeries(seriesRecord);
                }}
              >
                Edit
              </Button>
            )}
          </Row>
        </Card>
      </Modal>

      {/* Episodes Modal */}
      <Modal
        title={`${seriesTitleModalType} Title`}
        open={seriesTitleModal}
        onCancel={() => {
          setSeriesTitleModal(false);
          setSeriesRecord(null);
          setSeriesTitleModalType("Add");
          addSeriesTitleForm.resetFields();
          handleReset();
          setSeasonEpisodes([]);
        }}
        onOk={handleSeriesTitleSubmit}
        okText="Continue"
        maskClosable={false}
      >
        <Form layout="vertical" form={addSeriesTitleForm}>
          <Form.Item
            name={"title"}
            label="Series title"
            rules={[
              {
                required: true,
                validator: validateInputFields,
              },
            ]}
            extra={"English"}
          >
            <Input
              placeholder="Enter title here..."
              maxLength={255}
              showCount
            />
          </Form.Item>
          <Form.Item
            label="Synopsis (English)"
            name="description"
            rules={[
              {
                required: true,
                validator: validateDescriptionFields,
              },
            ]}
          >
            <TextArea rows={3} showCount maxLength={1000}></TextArea>
          </Form.Item>
          <Form.Item
            label="Slug"
            name={"slug"}
            rules={[
              {
                required: true,
                validator: validateInputSlug,
              },
            ]}
          >
            <Input
              placeholder="Enter slug"
              status="warning"
              suffix={
                <Tooltip title="Cannot Edit After Saving">
                  <InfoCircleOutlined />
                </Tooltip>
              }
              disabled={seriesTitleModalType === "Edit"}
            />
          </Form.Item>
          <Form.Item
            label="Category"
            name="category"
            rules={[{ required: true }]}
            initialValue={"Interviews"}
          >
            <Select
              defaultValue="Interviews"
              options={[
                { value: "Educational", label: "Educational" },
                { value: "Interviews", label: "Interviews" },
                { value: "Podcasts", label: "Podcasts" },
              ]}
            />
          </Form.Item>

          {/* gating for episodes content */}
          <Form.Item label="Gating Content" name="gating">
            <TreeSelect
              treeCheckable={true}
              showCheckedStrategy={TreeSelect.SHOW_CHILD}
              style={{ width: "100%" }}
              treeData={treeData}
              filterTreeNode={(input, option) =>
                option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            />
          </Form.Item>
          {/* <Form.Item
                          label="Title metadata language"
                          rules={[{ required: true }]}
                          extra="Choose a title metadata language that matches the language of your mezzanine or captions. "
                          name="metaLanguage"
                          initialValue={'english'}
                      >
                          <Select
                              defaultValue="english"
                              options={[
                                  { value: 'english', label: 'English' },
                                  { value: 'telugu', label: 'Telugu' },
                                  { value: 'hindi', label: 'Hindi' },
                              ]}
                          />
                      </Form.Item> */}
        </Form>
      </Modal>

      <Modal
        title="Create Episode"
        open={episodeModalVisible}
        onCancel={() => {
          episodeTItleForm.resetFields();
          setEpisodeModalVisible(false);
        }}
        onOk={handleCreateEpisode}
        okText="Create"
        maskClosable={false}
      >
        <Form form={episodeTItleForm} layout="vertical">
          <Form.Item
            name={"number"}
            label={"Episode Number"}
            rules={[
              {
                required: true,
                validator: validateNumberField,
              },
            ]}
          >
            <Input placeholder="Enter episode number" />
          </Form.Item>
          <Form.Item
            name={"title"}
            label={"Title"}
            rules={[
              {
                required: true,
                validator: validateInputFields,
              },
            ]}
          >
            <Input placeholder="Enter Title" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ManageMarkettingContent;
